(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  class AccordionList extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-accordion-trigger]'));
      const isDesktop = window.matchMedia('(min-width: 992px)').matches;

      this.triggers.forEach((trigger) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;

        const shouldOpen = isDesktop && trigger.hasAttribute('data-accordion-default-open-desktop');
        if (shouldOpen) {
          trigger.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        panel.style.maxHeight = shouldOpen ? `${panel.scrollHeight}px` : '0px';
        trigger.addEventListener('click', () => this.toggle(trigger, panel));
      });
    }

    toggle(trigger, panel) {
      const isOpen = trigger.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.style.maxHeight = isOpen ? `${panel.scrollHeight}px` : '0px';
    }
  }

  customElements.define('accordion-list', AccordionList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-text-and-image-slideshow"] && !Shopify.designMode) return;
  try {
    
  // Self-contained carousel scoped to this section only (not the shared
  // seamless-carousel in src/scripts/carousel.js, so zero risk to any
  // other section using that). Responsive: desktop (min-width: 992px,
  // matching the lg breakpoint the prev/next arrows themselves use via
  // `hidden lg:flex`) gets the same clone-based infinite loop as the
  // shared component; mobile gets plain scroll that stops at the real
  // first/last slide, since that's a touch-swipe experience with no
  // buttons anyway. Re-evaluates on resize if the breakpoint is crossed.
  class AffiliateHowToCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      this.originalChildren = Array.from(this.track.children);
      this.cloned = false;
      this.looping = false;
      this._anchored = false;

      this.prevButton && this.prevButton.addEventListener('click', () => this._step(-1));
      this.nextButton && this.nextButton.addEventListener('click', () => this._step(1));

      this.mql = window.matchMedia('(min-width: 992px)');
      this._onMqlChange = (event) => this._applyMode(event.matches);
      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this._onMqlChange);
      } else {
        this.mql.addListener(this._onMqlChange);
      }

      this._applyMode(this.mql.matches);
    }

    disconnectedCallback() {
      clearTimeout(this._scrollEndTimer);
      this._resizeObserver && this._resizeObserver.disconnect();
      if (this.mql) {
        if (this.mql.removeEventListener) {
          this.mql.removeEventListener('change', this._onMqlChange);
        } else {
          this.mql.removeListener(this._onMqlChange);
        }
      }
      if (this._boundOnScroll) {
        this.track.removeEventListener('scroll', this._boundOnScroll);
      }
    }

    _applyMode(isDesktop) {
      if (isDesktop === this.looping) return;
      this.looping = isDesktop;

      if (isDesktop) {
        this._enableLoop();
      } else {
        this._disableLoop();
      }
      this._updateButtonStates();
    }

    _enableLoop() {
      if (!this.cloned) {
        this._cloneOnce();
        this.cloned = true;
      }
      this._anchored = false;

      if (this.track.clientWidth > 0) {
        requestAnimationFrame(() => this._anchor());
      } else {
        this._resizeObserver = new ResizeObserver(() => {
          if (!this._anchored && this.track.clientWidth > 0) {
            this._anchor();
          }
        });
        this._resizeObserver.observe(this.track);
      }

      this._boundOnScroll = () => this._onScroll();
      this.track.addEventListener('scroll', this._boundOnScroll, { passive: true });
    }

    _disableLoop() {
      if (this._boundOnScroll) {
        this.track.removeEventListener('scroll', this._boundOnScroll);
        this._boundOnScroll = null;
      }
      this._resizeObserver && this._resizeObserver.disconnect();

      if (this.cloned) {
        Array.from(this.track.children).forEach((child) => {
          if (this.originalChildren.indexOf(child) === -1) {
            child.remove();
          }
        });
        this.cloned = false;
      }

      this._jumpTo(0);
      this._anchored = true;
      this.track.addEventListener('scroll', () => this._updateButtonStates(), { passive: true });
    }

    _cloneOnce() {
      const focusable = 'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
      this.originalChildren.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll(focusable).forEach(el => el.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      });

      [...this.originalChildren].reverse().forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll(focusable).forEach(el => el.setAttribute('tabindex', '-1'));
        this.track.insertBefore(clone, this.track.firstChild);
      });
    }

    _anchor() {
      this._anchored = true;
      this.setWidth = this.originalChildren[0].offsetLeft;
      this._jumpTo(this.setWidth);
      this._resizeObserver && this._resizeObserver.disconnect();
    }

    _jumpTo(left) {
      const previousBehavior = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      requestAnimationFrame(() => {
        this.track.style.scrollBehavior = previousBehavior;
      });
    }

    _getStep() {
      const cards = this.track.children;
      if (cards.length > 1) {
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }
      return this.track.clientWidth;
    }

    _step(direction) {
      if (!this._anchored) return;
      const step = this._getStep();

      if (!this.looping) {
        this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
        return;
      }

      const corrected = this._correctPosition();
      if (corrected) {
        requestAnimationFrame(() => {
          this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
        });
      } else {
        this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }
    }

    _onScroll() {
      if (!this._anchored) return;
      clearTimeout(this._scrollEndTimer);
      this._scrollEndTimer = setTimeout(() => this._correctPosition(), 100);
    }

    _correctPosition() {
      const { scrollLeft } = this.track;

      if (scrollLeft < this.setWidth) {
        this._jumpTo(scrollLeft + this.setWidth);
        return true;
      } else if (scrollLeft >= this.setWidth * 2) {
        this._jumpTo(scrollLeft - this.setWidth);
        return true;
      }
      return false;
    }

    _updateButtonStates() {
      if (this.looping) {
        if (this.prevButton) this.prevButton.disabled = false;
        if (this.nextButton) this.nextButton.disabled = false;
        return;
      }

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      if (this.prevButton) {
        this.prevButton.disabled = scrollLeft <= 1;
      }
      if (this.nextButton) {
        this.nextButton.disabled = scrollLeft >= maxScroll - 1;
      }
    }
  }

  customElements.define('affiliate-how-to-carousel', AffiliateHowToCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Always slides left (old message exits left, new one enters right), on
  // every tick including the wrap from the last message back to the first
  // one. A plain modulo-wrapped index can't do that alone: going from the
  // last index back to 0 means jumping the transform from a large
  // negative value back to 0%, and since the track's transform is always
  // transitioned, that jump would visibly animate *right* just for that
  // one step. Fixed the same way seamless (clone-based) carousels usually
  // are: a clone of the whole slide set is appended after the real ones,
  // so incrementing past the last real slide continues smoothly into a
  // lookalike instead of jumping forward, then — once that transition
  // finishes — silently (no transition) snaps back to the equivalent real
  // slide so the next tick can keep incrementing seamlessly forever.
  //
  // Clones are aria-hidden (screen readers skip them) but deliberately
  // NOT inert — inert also strips pointer-events, and if a clone (whose
  // content, including any link, is byte-identical to the real slide) is
  // what's on screen at the moment the silent reset fires, a click landing
  // on it should still work rather than silently hit-testing through to
  // nothing. Same lesson learned from a real bug in src/scripts/carousel.js.
  class AnnouncementBarSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-bar__slides');
      const originalSlides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (originalSlides.length < 2) return;

      this.cloneCount = originalSlides.length;
      originalSlides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        // Remove cloned focusable elements from tab order (WCAG 4.1.2 —
        // aria-hidden content must not contain tabbable elements).
        clone.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])').forEach(
          el => el.setAttribute('tabindex', '-1')
        );
        this.track.appendChild(clone);
      });

      this.current = 0;
      this._jumpTo(this.current, false);
      this.interval = setInterval(() => this.next(), 5000);
    }

    next() {
      this.current += 1;
      this._jumpTo(this.current, true);

      if (this.current >= this.cloneCount) {
        const resetTo = this.current - this.cloneCount;
        clearTimeout(this._resetTimer);
        this._resetTimer = setTimeout(() => {
          this.current = resetTo;
          this._jumpTo(this.current, false);
        }, 500);
      }
    }

    _jumpTo(index, animate) {
      if (!animate) {
        this.track.style.transition = 'none';
      }
      this.track.style.transform = `translateX(-${index * 100}%)`;
      if (!animate) {
        this.track.offsetHeight;
        this.track.style.transition = '';
      }
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      clearTimeout(this._resetTimer);
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-upsells"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var shopBlock = document.querySelector('.blog-post-grid__shop-articles');
    if (!shopBlock) return;

    var headingsH2 = document.querySelectorAll('.article__content h2:not(.blog-post-grid__newsletter-title)');
    var headings = headingsH2.length > 1 ? headingsH2 : document.querySelectorAll('.article__content h3');
    if (!headings.length) return;

    var manualMarker = document.getElementById('shop-articles');

    if (manualMarker) {
      manualMarker.appendChild(shopBlock);
    } else {
      var targetIndex = Math.floor(headings.length / 2);
      if (targetIndex > 1) targetIndex -= 1;
      var targetHeading = headings[targetIndex];
      if (targetHeading && targetHeading.parentNode) {
        targetHeading.parentNode.insertBefore(shopBlock, targetHeading);
      }
    }

    shopBlock.classList.remove('w-full');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ba-slider"] && !Shopify.designMode) return;
  try {
    
  class BaSliderComponent extends HTMLElement {
    connectedCallback() {
      this._initObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this._initObserver.disconnect();
              this._initObserver = null;
              this._init();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
      this._initObserver.observe(this);
    }

    _init() {
      this.overlay = this.querySelector('.ba-overlay');
      this.overlayImg = this.querySelector('.ba-overlay-img');
      this.bgImg = this.querySelector('.ba-bg-img');
      this.handle = this.querySelector('.ba-handle');
      this.clicked = false;

      if (!this.overlay || !this.handle) return;

      this._onMouseMove = this._onMouseMove.bind(this);
      this._onSlideReady = this._onSlideReady.bind(this);
      this._onSlideFinish = this._onSlideFinish.bind(this);
      this._onResize = this._setImgWidths.bind(this);

      this.addEventListener('mousemove', this._onMouseMove);
      this.addEventListener('touchmove', this._onMouseMove);

      this.handle.addEventListener('mousedown', (e) => {
        e.preventDefault();
        this._onSlideReady(e);
      });
      this.handle.addEventListener(
        'touchstart',
        (e) => {
          e.preventDefault();
          this._onSlideReady(e);
        },
        { passive: false }
      );

      window.addEventListener('mouseup', this._onSlideFinish);
      window.addEventListener('touchend', this._onSlideFinish);

      window.addEventListener('resize', this._onResize);

      if (this.bgImg.complete) {
        this._setImgWidths();
      } else {
        this.bgImg.addEventListener('load', () => this._setImgWidths(), { once: true });
      }
    }

    _setImgWidths() {
      if (!this.overlayImg) return;
      const w = this.offsetWidth;
      this.overlayImg.style.width = w + 'px';
      this.bgImg.style.width = w + 'px';

      const half = w / 2;
      this.overlay.style.width = half + 'px';
      this.handle.style.left = half - 30 + 'px';
    }

    _slide(x) {
      let pos = x - this.handle.offsetWidth / 2;
      if (window.innerWidth < 768 && pos < -30) pos = -30;
      if (window.innerWidth < 768 && pos > window.innerWidth - 30) pos = window.innerWidth - 30;
      this.overlay.style.width = x + 'px';
      this.handle.style.left = pos + 'px';
    }

    _getCursorPos(e) {
      e = e.changedTouches ? e.changedTouches[0] : e;
      const a = this.overlay.getBoundingClientRect();
      let x = e.pageX - a.left;
      x -= window.pageXOffset;
      return x;
    }

    _onMouseMove(e) {
      if (!this.clicked) return;
      let pos = this._getCursorPos(e);
      if (pos < 0) pos = 0;
      this._slide(pos);
    }

    _onSlideReady(e) {
      e.preventDefault();
      this.clicked = true;
      document.body.classList.add('no-select');
    }

    _onSlideFinish() {
      this.clicked = false;
      document.body.classList.remove('no-select');
    }

    disconnectedCallback() {
      if (this._initObserver) this._initObserver.disconnect();
      window.removeEventListener('mouseup', this._onSlideFinish);
      window.removeEventListener('touchend', this._onSlideFinish);
      window.removeEventListener('resize', this._onResize);
    }
  }

  customElements.define('ba-slider-component', BaSliderComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-heading-nav"] && !Shopify.designMode) return;
  try {
    
  class BlogHeadingNav extends HTMLElement {
    connectedCallback() {
      this.fallbackNormalIds = (this.dataset.normalContentIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      this.fallbackHowtoIds = (this.dataset.howtoContentIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      this.toggleLink = this.querySelector('[data-howto-toggle]');
      this.navLinks = Array.from(this.querySelectorAll('[data-blog-nav-link]'));

      // Hide how-to content immediately so nothing flashes visible on a
      // normal page load.
      this.setState(false);

      if (this.toggleLink) {
        this.toggleLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.setState(true);
          history.pushState(null, '', '?how-to-tab=true#how-to-tab');
        });
      }

      const url = window.location.href;
      if (url.includes('how-to-tab=true') || url.includes('#how-to-tab')) {
        this.setState(true);
      }
    }

    sectionEl(id) {
      return document.getElementById('shopify-section-' + id);
    }

    setState(showHowTo) {
      // Primary: fixed markers baked into each section's own markup —
      // survives sections being deleted/re-added.
      document.querySelectorAll('[data-blog-content="normal"]').forEach((el) => {
        el.classList.toggle('hidden', showHowTo);
      });
      document.querySelectorAll('[data-blog-content="howto"]').forEach((el) => {
        el.classList.toggle('hidden', !showHowTo);
      });

      // Fallback: ID-based, only for sections that can't carry a marker.
      this.fallbackNormalIds.forEach((id) => {
        const el = this.sectionEl(id);
        if (el) el.classList.toggle('hidden', showHowTo);
      });
      this.fallbackHowtoIds.forEach((id) => {
        const el = this.sectionEl(id);
        if (el) el.classList.toggle('hidden', !showHowTo);
      });

      if (showHowTo) {
        this.navLinks.forEach((link) => link.classList.remove('active-dark'));
        if (this.toggleLink) this.toggleLink.classList.add('active-dark');
      }
    }
  }

  customElements.define('blog-heading-nav', BlogHeadingNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-load-more-articles"] && !Shopify.designMode) return;
  try {
    
  class LoadMoreArticles extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.targetCount = parseInt(this.dataset.targetCount, 10) || 9;
      this.list = this.querySelector('[data-articles-list]');
      this.wrapper = this.querySelector('[data-load-more-wrapper]');
      this.spinner = this.querySelector('[data-load-more-spinner]');
      this.bindLink();
    }

    bindLink() {
      const link = this.wrapper ? this.wrapper.querySelector('[data-load-more-link]') : null;
      if (!link) return;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.loadMore(link.getAttribute('href'), link);
      });
    }

    sectionUrl(pageUrl) {
      const separator = pageUrl.indexOf('?') === -1 ? '?' : '&';
      return pageUrl + separator + 'section_id=' + this.sectionId;
    }

    existingHandles() {
      const handles = new Set();
      document.querySelectorAll('[data-article-handle]').forEach((el) => {
        handles.add(el.getAttribute('data-article-handle'));
      });
      return handles;
    }

    async loadMore(startUrl, triggerLink) {
      if (this.wrapper) this.wrapper.classList.add('hidden');
      if (this.spinner) this.spinner.classList.remove('hidden');

      let nextUrl = startUrl;
      let newCardsCount = 0;

      try {
        while (nextUrl && newCardsCount < this.targetCount) {
          const response = await fetch(this.sectionUrl(nextUrl));
          if (!response.ok) break;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newList = doc.querySelector('[data-articles-list]');
          const fetchedCards = newList ? Array.from(newList.children) : [];
          const seen = this.existingHandles();

          for (let i = 0; i < fetchedCards.length; i++) {
            if (newCardsCount >= this.targetCount) break;
            const card = fetchedCards[i];
            const handle = card.getAttribute('data-article-handle');
            if (handle && seen.has(handle)) continue;
            if (handle) seen.add(handle);
            this.list.appendChild(card);
            newCardsCount++;
          }

          const newWrapper = doc.querySelector('[data-load-more-wrapper]');
          if (newWrapper && this.wrapper) {
            this.wrapper.outerHTML = newWrapper.outerHTML;
            this.wrapper = this.querySelector('[data-load-more-wrapper]');
            this.wrapper.classList.add('hidden');
            this.bindLink();
          } else if (this.wrapper) {
            this.wrapper.remove();
            this.wrapper = null;
          }

          const nextLink = newWrapper ? newWrapper.querySelector('[data-load-more-link]') : null;
          nextUrl = nextLink ? nextLink.getAttribute('href') : null;
        }
      } finally {
        if (this.spinner) this.spinner.classList.add('hidden');
        if (this.wrapper) this.wrapper.classList.remove('hidden');
      }
    }
  }

  customElements.define('load-more-articles', LoadMoreArticles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byob-main"] && !Shopify.designMode) return;
  try {
    
  class ByobTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabNavs = this.querySelectorAll('.byob-tab-nav');
      this.tabContents = this.querySelectorAll('.byob-tab-content');

      this.tabNavs.forEach((nav) => {
        nav.addEventListener('click', (event) => this.onTabClick(event));
      });
    }

    onTabClick(event) {
      const clickedNav = event.currentTarget;
      const targetId = clickedNav.getAttribute('data-target');

      // Reset all navs
      this.tabNavs.forEach((n) => {
        n.classList.remove('nav--active', 'bg-body', 'text-white', 'font-normal', 'hover:text-white');
        n.classList.add('bg-white', 'text-gray-600', 'hover:text-primary');
      });

      // Set active nav
      clickedNav.classList.add('nav--active', 'bg-body', 'text-white', 'font-normal', 'hover:text-white');
      clickedNav.classList.remove('bg-white', 'text-gray-600', 'hover:text-primary');

      // Hide all contents
      this.tabContents.forEach((content) => {
        content.classList.add('hidden');
      });

      // Show active content
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.classList.remove('hidden');
      }
    }
  }

  if (!customElements.get('byob-tabs')) {
    customElements.define('byob-tabs', ByobTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var isWindows = /windows/i.test(navigator.userAgent);
    if (!isWindows) return;

    document.querySelectorAll('.collection-sort__select').forEach(function (select) {
      select.classList.remove('pl-0', 'text-right', 'lg:w-[185px]');
      select.classList.add('pl-1', 'text-left', 'lg:w-[150px]');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coming-soon"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.klaviyo_form_trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var formId = trigger.dataset.klaviyoFormId;
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
  class ContentTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-content-tabs-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-content-tabs-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.contentTabsTab));
      });

      this.accordionTriggers = Array.from(this.querySelectorAll('[data-content-tabs-accordion-trigger]'));
      this.accordionTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.toggleAccordion(trigger));
      });

      // The panel that starts expanded (aria-expanded="true") is rendered
      // with the CSS default max-h-0 until this runs — switch it to a real
      // pixel value (measured from its actual content) so the *next*
      // toggle (collapsing it) has something numeric to animate from.
      // max-height can't transition to/from "none", only between numbers.
      this.accordionTriggers.forEach((trigger) => {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          this.setPanelHeight(trigger, true);
        }
      });
    }

    selectTab(key) {
      this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.contentTabsTab === key));
      this.panels.forEach((panel) => panel.classList.toggle('hidden', panel.dataset.contentTabsPanel !== key));
    }

    setPanelHeight(trigger, open) {
      const item = trigger.closest('[data-content-tabs-accordion-item]');
      const panel = item.querySelector('[data-content-tabs-accordion-panel]');
      panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
    }

    toggleAccordion(trigger) {
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';

      this.accordionTriggers.forEach((otherTrigger) => {
        otherTrigger.setAttribute('aria-expanded', 'false');
        this.setPanelHeight(otherTrigger, false);
        const icon = otherTrigger.querySelector('[data-content-tabs-accordion-icon]');
        if (icon) icon.textContent = '+';
      });

      if (willOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        this.setPanelHeight(trigger, true);
        const icon = trigger.querySelector('[data-content-tabs-accordion-icon]');
        if (icon) icon.textContent = '−';
      }
    }
  }

  customElements.define('content-tabs', ContentTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eu-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-eu-withdrawal-form-root]').forEach((root) => {
    const form = root.querySelector('[data-eu-withdrawal-form]');
    if (!form) return;

    const formState = root.querySelector('[data-eu-withdrawal-form-state]');
    const successState = root.querySelector('[data-eu-withdrawal-success-state]');
    const errorEl = root.querySelector('[data-eu-withdrawal-error]');
    const submitButton = root.querySelector('[data-eu-withdrawal-submit]');
    const submitLabel = root.querySelector('[data-eu-withdrawal-submit-label]');
    const idleLabel = submitLabel ? submitLabel.textContent : '';
    const submittingLabel = submitLabel ? submitLabel.dataset.submittingLabel : '';

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      errorEl && errorEl.classList.add('hidden');
      submitButton && (submitButton.disabled = true);
      submitLabel && submittingLabel && (submitLabel.textContent = submittingLabel);

      const data = new FormData(form);
      const payload = {
        firstName: data.get('firstName') || '',
        lastName: data.get('lastName') || '',
        email: data.get('email') || '',
        products: data.get('products') || '',
        orderNumber: data.get('orderNumber') || '',
        date: data.get('date') || '',
        reason: data.get('reason') || '',
      };

      fetch('https://s-app.cocoandeve.com/gorgias/eu-withdrawal', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Request failed');
          formState && formState.classList.add('hidden');
          successState && successState.classList.remove('hidden');
        })
        .catch(() => {
          errorEl && errorEl.classList.remove('hidden');
          submitButton && (submitButton.disabled = false);
          submitLabel && (submitLabel.textContent = idleLabel);
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class DropdownStore extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-toggle]');
      this.menu = this.querySelector('[data-menu]');

      this.toggle.addEventListener('click', () => this.toggleMenu());
      this.onOutsideClick = (e) => {
        if (!this.contains(e.target) && this.menu.classList.contains('opacity-100')) {
          this.closeMenu();
        }
      };
      document.addEventListener('click', this.onOutsideClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutsideClick);
    }

    toggleMenu() {
      const isOpen = !this.menu.classList.contains('opacity-100');
      if (isOpen) {
        const height = this.menu.scrollHeight; // measures actual content height
        this.menu.classList.add('opacity-100');
        this.menu.style.height = `${height}px`;
        this.menu.style.transform = `translate3d(0px, -${height}px, 0px)`;
      } else {
        this.closeMenu();
      }
    }

    closeMenu() {
      this.menu.classList.remove('opacity-100');
      this.menu.style.height = '';
      this.menu.style.transform = '';
    }
  }

  customElements.define('dropdown-store', DropdownStore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this._placeholder = null;
      this._isSticky = false;
      this._onScroll = this._handleScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
    }

    _handleScroll() {
      const scrollY = window.scrollY;
      if (scrollY > 0 && !this._isSticky && !window.__pageTemplate.includes('page.quiz')) {
        this._isSticky = true;
        this.classList.add('is-sticky');
        document.body.classList.add('has-sticky-header');
        this._ensurePlaceholder();
      } else if (scrollY === 0 && this._isSticky) {
        this._isSticky = false;
        this.classList.remove('is-sticky');
        document.body.classList.remove('has-sticky-header');
        if (this._placeholder) {
          this._placeholder.style.height = '0';
        }
      }
    }

    _ensurePlaceholder() {
      if (!this._placeholder) {
        this._placeholder = document.createElement('div');
        this._placeholder.className = 'sticky-header-placeholder';
        this.insertAdjacentElement('afterend', this._placeholder);
      }
      // The announcement bar and timer bar sit outside <sticky-header> as
      // preceding siblings, but they also go position: fixed while sticky
      // (see src/styles/header.css), so their vacated space needs
      // compensating for here too — otherwise the page jumps up.
      const announcementBar = document.getElementById('announcement-bar');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const timerBar = document.getElementById('timer-bar');
      const timerBarHeight = timerBar && !timerBar.classList.contains('hidden') ? timerBar.offsetHeight : 0;
      this._placeholder.style.height = this.offsetHeight + announcementBarHeight + timerBarHeight + 'px';
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Same link text, different destination: a screen reader user tabbing or
  // listing links hears "Hair" twice (main nav's collection, a blog category
  // tab) or a product title twice (article body, upsell card) with no way to
  // tell them apart. These pairs usually cross sections — nav vs. merchant
  // content — so no single Liquid file can see both; this pass runs over the
  // whole rendered page instead.
  //
  // Links are grouped by accessible name. In a group that points at more than
  // one destination, links to the first destination keep their name; every
  // other link gets an aria-label of its visible text plus a short description
  // of where it goes ("Hair: hair collection"), starting with the visible text
  // so voice control still matches. Links sharing both text and destination
  // are fine and left alone, as is any link that already has an aria-label.
  (function () {
    function describeUrl(url) {
      if (url.origin !== window.location.origin) return url.hostname.replace(/^www\./, '');
      const words = (segment) => decodeURIComponent(segment || '').replace(/[-_]+/g, ' ').trim();
      const parts = url.pathname.split('/').filter(Boolean);
      let description;

      if (parts.length === 0) {
        description = 'home page';
      } else if (parts.includes('products')) {
        description = words(parts[parts.indexOf('products') + 1]) + ' product page';
      } else if (parts[0] === 'collections') {
        description = words(parts[1]) + ' collection';
      } else if (parts[0] === 'blogs' && parts[2] === 'tagged') {
        description = words(parts[3]) + ' articles';
      } else if (parts[0] === 'blogs') {
        description = parts[2] ? words(parts[2]) : 'blog';
      } else if (parts[0] === 'pages') {
        description = words(parts[1]) + ' page';
      } else {
        description = words(parts[parts.length - 1]);
      }

      const page = url.searchParams.get('page');
      if (page) description += ', page ' + page;
      return description;
    }

    function labelDuplicateLinks() {
      const groups = new Map();

      document.querySelectorAll('a[href]').forEach((link) => {
        if (link.closest('[aria-hidden="true"]') || link.hasAttribute('aria-labelledby')) return;
        const name = (link.getAttribute('aria-label') || link.textContent).replace(/\s+/g, ' ').trim();
        if (!name) return;

        let url;
        try {
          url = new URL(link.href, window.location.href);
        } catch (error) {
          return;
        }
        if (!/^https?:$/.test(url.protocol)) return;
        url.hash = '';

        const key = name.toLowerCase();
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push({ link, name, url, destination: url.href });
      });

      groups.forEach((entries) => {
        const destinations = [...new Set(entries.map((entry) => entry.destination))];
        if (destinations.length < 2) return;

        const usedLabels = new Set([entries[0].name.toLowerCase()]);
        const labelFor = new Map();

        destinations.slice(1).forEach((destination, index) => {
          const entry = entries.find((item) => item.destination === destination);
          let label = entry.name + ': ' + describeUrl(entry.url);
          if (usedLabels.has(label.toLowerCase())) label = entry.name + ' (link ' + (index + 2) + ')';
          usedLabels.add(label.toLowerCase());
          labelFor.set(destination, label);
        });

        entries.forEach(({ link, destination }) => {
          if (labelFor.has(destination) && !link.hasAttribute('aria-label')) {
            link.setAttribute('aria-label', labelFor.get(destination));
          }
        });
      });
    }

    // Links reading just "here" or "read more" say nothing when a screen
    // reader lists or tabs through links out of context. They come from
    // merchant-written content (article bodies, product descriptions, retailer
    // blocks), so they're named here: the aria-label becomes the sentence the
    // link sits in ("If we don't stock near you, you can buy online here"),
    // which contains the visible text and so still matches for voice control.
    // When no usable sentence is found, fall back to the visible text plus
    // where the link goes ("here: bit.ly"). Runs before the duplicate pass so
    // that pass sees these new names.
    const VAGUE_LINK_TEXT = new Set([
      'here', 'click here', 'tap here', 'click', 'this', 'this link', 'link',
      'more', 'read more', 'learn more', 'find out more', 'see more', 'more info', 'details',
    ]);

    function surroundingSentence(link, text) {
      const block = link.parentElement && link.parentElement.closest('p, li, td, th, dd, figcaption, h1, h2, h3, h4, h5, h6, div');
      if (!block) return null;

      const range = document.createRange();
      range.selectNodeContents(block);
      range.setEndBefore(link);
      const before = range.toString();
      range.selectNodeContents(block);
      range.setStartAfter(link);
      const after = range.toString();

      const start = before.split(/[.!?]\s/).pop();
      const end = after.split(/[.!?](\s|$)/)[0];
      const sentence = (start + text + end).replace(/\s+/g, ' ').trim();

      if (sentence.length <= text.length + 3 || sentence.length > 150) return null;
      return sentence;
    }

    function labelVagueLinks() {
      document.querySelectorAll('a[href]').forEach((link) => {
        if (link.hasAttribute('aria-label') || link.hasAttribute('aria-labelledby')) return;
        const text = link.textContent.replace(/\s+/g, ' ').trim();
        const key = text.toLowerCase().replace(/[.!?:…]+$/, '');
        if (!VAGUE_LINK_TEXT.has(key)) return;

        let label = surroundingSentence(link, text);
        if (!label) {
          let description;
          try {
            description = describeUrl(new URL(link.href, window.location.href));
          } catch (error) {
            return;
          }
          if (!description) return;
          label = text + ': ' + description;
        }
        link.setAttribute('aria-label', label);
      });
    }

    // A target="_blank" link has to warn that it opens a new window. Checkers
    // accept the warning in the link text or a `title`, not an aria-label, so
    // every such link gets title="Opens in a new window" — screen readers
    // announce it as the link's description. Theme templates and article
    // bodies (main-article.liquid) write it server-side, since checkers read
    // the rendered HTML; this catches the rest (product descriptions, pages,
    // rich text settings) for real visitors. A link with its own title, or
    // whose name already mentions a new window/tab, is left alone.
    function describeNewWindowLinks() {
      document.querySelectorAll('a[target="_blank"]').forEach((link) => {
        if (link.hasAttribute('title')) return;
        const name = link.getAttribute('aria-label') || link.textContent;
        if (/new (window|tab)/i.test(name)) return;
        link.setAttribute('title', 'Opens in a new window');
      });
    }

    function labelLinks() {
      labelVagueLinks();
      labelDuplicateLinks();
      describeNewWindowLinks();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', labelLinks);
    } else {
      labelLinks();
    }
  })();

  (function () {
    const siteHeader = document.getElementById('site-header');
    if (!siteHeader) return;

    function setHeaderHeightVar() {
      document.documentElement.style.setProperty('--site-header-height', siteHeader.offsetHeight + 'px');
    }

    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);
  })();

  (function () {
    const announcementBar = document.getElementById('announcement-bar');
    if (!announcementBar) return;

    function setAnnouncementBarHeightVar() {
      document.documentElement.style.setProperty('--announcement-bar-height', announcementBar.offsetHeight + 'px');
    }

    setAnnouncementBarHeightVar();
    window.addEventListener('resize', setAnnouncementBarHeightVar);
  })();

  (function () {
    const toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
    const closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
    const overlay = document.querySelector('[data-mobile-menu-overlay]');
    const nav = document.getElementById('mobile-nav');
    const submenuTriggers = document.querySelectorAll('[data-mobile-submenu-trigger]');
    const submenuBackBtns = document.querySelectorAll('[data-mobile-submenu-back]');
    const banners = document.querySelectorAll('[data-mobile-nav-banner-copy]');
    if (!toggleBtn || !nav) return;

    function closeAllSubmenus() {
      document.querySelectorAll('[data-mobile-submenu].is-open').forEach((submenu) => {
        submenu.classList.remove('is-open');
      });
    }

    function openMenu() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggleBtn.setAttribute('aria-expanded', 'false');
      closeAllSubmenus();
    }

    toggleBtn.addEventListener('click', openMenu);
    closeBtns.forEach((btn) => btn.addEventListener('click', closeMenu));
    overlay && overlay.addEventListener('click', closeMenu);

    submenuTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const submenu = document.getElementById(trigger.dataset.mobileSubmenuTrigger);
        submenu && submenu.classList.add('is-open');
      });
    });
    submenuBackBtns.forEach((backBtn) => {
      backBtn.addEventListener('click', () => {
        const submenu = backBtn.closest('[data-mobile-submenu]');
        submenu && submenu.classList.remove('is-open');
      });
    });
    banners.forEach((banner) => {
      banner.addEventListener('click', () => {
        const code = banner.dataset.discountCode;
        if (!code) return;
        navigator.clipboard.writeText(code);
        const cta = banner.querySelector('[data-mobile-nav-banner-cta]');
        if (!cta) return;
        const original = cta.textContent;
        cta.textContent = banner.dataset.copiedLabel || original;
        setTimeout(() => {
          cta.textContent = original;
        }, 2000);
      });
    });
  })();

  (function () {
    const countryToggle = document.getElementById('countrySelect');
    const countryPanel = document.getElementById('collapseCountry');
    if (!countryToggle || !countryPanel) return;

    const toggleCountryPanel = () => {
      const isOpen = countryPanel.classList.toggle('is-open');
      countryToggle.classList.toggle('collapsed', !isOpen);
      countryToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    countryToggle.addEventListener('click', toggleCountryPanel);
    countryToggle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleCountryPanel();
      }
    });
  })();

  (function () {
    const searchToggleBtn = document.querySelector('[data-search-toggle]');
    const searchPanel = document.querySelector('[data-search-panel]');
    const searchCloseBtn = document.querySelector('[data-search-close]');
    const searchClearBtn = document.querySelector('[data-search-clear]');
    const searchInput = document.querySelector('[data-search-input]');
    const searchTagBtns = document.querySelectorAll('[data-search-tag]');
    const searchPopular = document.querySelector('[data-search-popular]');
    const searchResult = document.querySelector('[data-search-result]');
    if (!searchToggleBtn || !searchPanel) return;

    const predictiveSearchUrl = searchPanel.dataset.predictiveSearchUrl;
    let searchDebounce;
    let searchAbortController;

    function isOpen() {
      return searchPanel.classList.contains('is-open');
    }

    function openSearch() {
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      searchToggleBtn.setAttribute('aria-expanded', 'true');
      searchInput && searchInput.focus();
    }

    function closeSearch() {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggleBtn.setAttribute('aria-expanded', 'false');
    }

    function showPopular() {
      searchPopular && searchPopular.classList.remove('hidden');
      searchResult && searchResult.classList.add('hidden');
    }

    function showResults() {
      searchPopular && searchPopular.classList.add('hidden');
      searchResult && searchResult.classList.remove('hidden');
    }

    async function runPredictiveSearch(term) {
      if (!searchResult || !predictiveSearchUrl) return;

      if (typeof window.trackEvent === 'function') {
        window.trackEvent('search_keyword', {
          category: 'Search Box',
          search_term: term,
        });
      }

      searchAbortController && searchAbortController.abort();
      searchAbortController = new AbortController();

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': 8,
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search',
      });

      try {
        const response = await fetch(`${predictiveSearchUrl}?${params.toString()}`, {
          signal: searchAbortController.signal,
        });
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const results = doc.querySelector('#predictive-search-results');
        searchResult.innerHTML = results ? results.innerHTML : '';
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }

    function searchCarouselScrollBy(track, direction) {
      track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
    }

    searchToggleBtn.addEventListener('click', () => (isOpen() ? closeSearch() : openSearch()));
    searchCloseBtn && searchCloseBtn.addEventListener('click', closeSearch);
    function setClearVisible(visible) {
      if (!searchClearBtn) return;
      searchClearBtn.style.opacity = visible ? '1' : '';
    }

    searchClearBtn &&
      searchClearBtn.addEventListener('click', () => {
        if (!searchInput) return;
        searchInput.value = '';
        searchInput.focus();
        clearTimeout(searchDebounce);
        setClearVisible(false);
        showPopular();
      });
    searchTagBtns.forEach((tagBtn) => {
      tagBtn.addEventListener('click', () => {
        if (!searchInput) return;
        const term = tagBtn.textContent.trim();
        searchInput.value = term;
        searchInput.focus();
        clearTimeout(searchDebounce);
        setClearVisible(term !== '');
        showResults();
        runPredictiveSearch(term);
      });
    });
    searchInput &&
      searchInput.addEventListener('input', () => {
        const term = searchInput.value.trim();
        clearTimeout(searchDebounce);
        setClearVisible(term !== '');

        if (term === '') {
          searchAbortController && searchAbortController.abort();
          showPopular();
          return;
        }

        showResults();
        searchDebounce = setTimeout(() => runPredictiveSearch(term), 300);
      });
    searchResult &&
      searchResult.addEventListener('click', (event) => {
        const track = searchResult.querySelector('[data-search-carousel-track]');
        if (!track) return;
        if (event.target.closest('[data-search-carousel-prev]')) searchCarouselScrollBy(track, -1);
        if (event.target.closest('[data-search-carousel-next]')) searchCarouselScrollBy(track, 1);
      });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) closeSearch();
    });

    // Mega menus open on pure CSS :hover and :focus-within (see
    // src/styles/header.css) with no JS involved - so reaching a nav item
    // while the search panel is open would otherwise show both at once.
    // focusin covers the keyboard path, mouseenter the pointer one. mouseenter
    // doesn't bubble, so each nav-item needs its own listener rather than one
    // delegated listener on the nav list; focusin is bound alongside it there
    // (it does bubble, which is what lets it fire for the panel's own links).
    document.querySelectorAll('.nav-item').forEach((navItem) => {
      const closeSearchIfOpen = () => {
        if (isOpen()) closeSearch();
      };

      navItem.addEventListener('mouseenter', closeSearchIfOpen);
      navItem.addEventListener('focusin', closeSearchIfOpen);
    });
  })();

  (function () {
    const bubble = document.querySelector('[data-cart-bubble]');
    const closeBtn = document.querySelector('[data-cart-bubble-close]');
    const textEl = document.querySelector('[data-cart-bubble-text]');
    const countEl = document.querySelector('[data-cart-bubble-count]');
    const checkoutLink = document.querySelector('[data-cart-bubble-checkout-link]');
    if (!bubble) return;

    const defaultText = textEl ? textEl.textContent : '';
    const totalItemsTemplate = bubble.dataset.totalItemsText || '';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const HIDDEN_CLASSES = ['invisible', 'opacity-0', '-translate-y-[var(--site-header-height)]'];
    const VISIBLE_CLASSES = ['visible', 'opacity-100', '-translate-y-[0%]'];
    let hideTimeout = null;
    // Tracks whether focus has already been moved into the bubble for its
    // current appearance - focus is given once per appearance, never
    // re-grabbed while it's still visible (so clicking/tabbing away works
    // normally), and resets once the bubble hides so the next appearance
    // focuses again.
    let hasFocused = false;

    function hideBubble() {
      bubble.classList.remove(...VISIBLE_CLASSES);
      bubble.classList.add(...HIDDEN_CLASSES);
      clearTimeout(hideTimeout);
      hasFocused = false;
    }

    // isError hides the "Proceed to checkout" link - it doesn't make sense
    // to offer checkout right after telling the shopper something couldn't
    // be added - leaving just the message on its own.
    function showBubble(message, isError) {
      const wasHidden = bubble.classList.contains('invisible');

      if (textEl) textEl.textContent = message || defaultText;
      if (checkoutLink) checkoutLink.classList.toggle('hidden', Boolean(isError));

      if (countEl) {
        if (isError) {
          countEl.textContent = '';
        } else if (totalItemsTemplate) {
          fetch(`${root}cart.js`)
            .then((response) => response.json())
            .then((cart) => {
              countEl.textContent = totalItemsTemplate.replace('%%COUNT%%', cart.item_count);
            })
            .catch(() => {});
        }
      }

      bubble.classList.remove(...HIDDEN_CLASSES);
      bubble.classList.add(...VISIBLE_CLASSES);

      if (wasHidden && !hasFocused) {
        bubble.focus({ preventScroll: true });
        hasFocused = true;
      }

      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(hideBubble, 5000);
    }

    document.addEventListener('cart:bubble', (event) => {
      showBubble(event.detail && event.detail.message, event.detail && event.detail.isError);
    });

    closeBtn && closeBtn.addEventListener('click', hideBubble);
  })();

  /* ── Loyalty points (Bali Beauty Club) ─────────────────────────────────
   * When the customer is logged in, poll window.swellAPI.getCustomerDetails()
   * until the SDK has fully initialised (actionHistoryItems populated),
   * then read pointsBalance and update both the desktop header and
   * mobile nav elements. While waiting, a spinner is shown.
   * ────────────────────────────────────────────────────────────────────── */
  (function () {
    var config = window.__loyaltyConfig || {};
    if (!config.isLoggedIn || !config.customerEmail) return;

    /* ── Desktop elements ─────── */
    var desktopLabel = document.getElementById('loyalty-desktop-label');
    var desktopSpinner = document.getElementById('loyalty-desktop-spinner');
    var desktopLink = document.getElementById('loyalty-desktop-link');

    /* ── Mobile elements ──────── */
    var mobileGuest = document.getElementById('loyalty-mobile-guest');
    var mobileAuthed = document.getElementById('loyalty-mobile-authed');
    var mobilePoints = document.getElementById('loyalty-mobile-points');
    var mobilePtsTxt = document.getElementById('loyalty-mobile-points-text');
    var mobileSpinner = document.getElementById('loyalty-mobile-spinner');

    /* ── Desktop: switch to loading state ─────── */
    if (desktopLabel) desktopLabel.classList.add('hidden');
    if (desktopSpinner) {
      desktopSpinner.classList.remove('hidden');
      desktopSpinner.classList.add('flex');
    }
    if (desktopLink) {
      desktopLink.href = '/pages/rewards';
      desktopLink.classList.add('lg:items-center');
    }

    /* ── Mobile: switch to authed/loading state ── */
    if (mobileGuest) mobileGuest.classList.add('hidden');
    if (mobileAuthed) mobileAuthed.classList.remove('hidden');
    if (mobilePoints) mobilePoints.classList.add('hidden');
    if (mobileSpinner) mobileSpinner.classList.remove('hidden');

    /* Navigate to /pages/rewards on mobile button click */
    if (mobileAuthed) {
      mobileAuthed.addEventListener('click', function () {
        window.location.href = '/pages/rewards';
        if (window.location.pathname === '/pages/rewards') window.location.reload();
      });
    }

    /* ── Show points in both desktop and mobile ─────────── */
    function showPoints(pts) {
      var pointsText = pts + ' Points';

      /* Desktop */
      if (desktopLabel) {
        desktopLabel.textContent = pointsText;
        desktopLabel.classList.remove('hidden');
      }
      if (desktopSpinner) {
        desktopSpinner.classList.add('hidden');
        desktopSpinner.classList.remove('flex');
      }
      if (desktopLink) desktopLink.classList.remove('lg:items-center');

      /* Mobile */
      if (mobilePtsTxt) mobilePtsTxt.textContent = pointsText;
      if (mobilePoints) mobilePoints.classList.remove('hidden');
      if (mobileSpinner) mobileSpinner.classList.add('hidden');
    }

    /* ── Poll until swellAPI is ready ─────────── */
    var waitForApi = function (condition, cb, maxRetries) {
      if (typeof condition === 'function' && typeof cb === 'function') {
        var retries = maxRetries || 0;
        setTimeout(function () {
          try {
            if (condition()) {
              cb();
            } else if (retries < 150) {
              waitForApi(condition, cb, retries + 1);
            }
          } catch (e) {
            /* condition threw – keep retrying */
            if (retries < 150) waitForApi(condition, cb, retries + 1);
          }
        }, 200);
      }
    };

    /* ── Track initial state on page load and calculate delta points ─────────── */
    var loyaltyState = {
      sdkReady: false,    /* true only after startLoyaltyPolling confirms real SDK data */
      initialized: false,
      basePoints: 0,
      initialCartPoints: 0,
    };

    var getCartSwellPoints = function (cart) {
      if (!cart || !cart.items || !cart.items.length) return 0;
      var total = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.properties) {
          var props = item.properties;
          var swellVal = null;
          if (Array.isArray(props)) {
            var found = props.find(function (p) {
              return (
                p[0] === '_swell_points_used' ||
                p.key === '_swell_points_used' ||
                p[0] === '_swell_reward_points' ||
                p.key === '_swell_reward_points' ||
                p[0] === 'points_used' ||
                p.key === 'points_used' ||
                p[0] === '_points_used' ||
                p.key === '_points_used'
              );
            });
            swellVal = found ? found[1] || found.value : null;
          } else {
            swellVal =
              props._swell_points_used || props._swell_reward_points || props.points_used || props._points_used;
          }
          if (swellVal) {
            var pts = parseInt(swellVal, 10);
            if (!isNaN(pts) && pts > 0) {
              total += pts * (item.quantity || 1);
            }
          }
        }
      }
      return total;
    };

    var updatePointsFromCart = function () {
      /* Don't run until startLoyaltyPolling has confirmed real SDK data */
      if (!loyaltyState.sdkReady) return;
      if (!window.swellAPI || typeof window.swellAPI.getCustomerDetails !== 'function') return;
      var customer = window.swellAPI.getCustomerDetails();
      var currentBase = customer && customer.pointsBalance !== undefined ? customer.pointsBalance : 0;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window
        .fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var cartPts = getCartSwellPoints(cart);
          if (!loyaltyState.initialized) {
            loyaltyState.initialized = true;
            loyaltyState.basePoints = currentBase;
            loyaltyState.initialCartPoints = cartPts;
          }
          var delta = cartPts - loyaltyState.initialCartPoints;
          var effective = Math.max(0, loyaltyState.basePoints - delta);
          console.log(
            '[loyalty] basePoints:',
            loyaltyState.basePoints,
            'initialCart:',
            loyaltyState.initialCartPoints,
            'currentCart:',
            cartPts,
            'delta:',
            delta,
            'display:',
            effective
          );
          showPoints(effective);
        })
        .catch(function () {
          showPoints(currentBase);
        });
    };

    /* ── Start polling for points ── */
    function startLoyaltyPolling() {
      loyaltyState.sdkReady = false;
      loyaltyState.initialized = false;
      loyaltyState.basePoints = 0;
      loyaltyState.initialCartPoints = 0;

      var sdkAvailableChecks = 0;
      waitForApi(
        function () {
          console.log('window swellapi', window.swellAPI);
          console.log('window typeof swellapi', window.swellAPI && typeof window.swellAPI.getCustomerDetails);
          if (!window.swellAPI || typeof window.swellAPI.getCustomerDetails !== 'function') return false;
          var customer = window.swellAPI.getCustomerDetails();
          console.log('customer', customer);
          if (!customer || typeof customer.pointsBalance !== 'number') return false;

          // SDK is available — start counting
          sdkAvailableChecks++;

          // Real data loaded
          if (customer.pointsBalance > 0) return true;

          // After ~10 seconds with SDK available but pointsBalance still 0,
          // accept it as genuine (customer truly has 0 points)
          if (sdkAvailableChecks >= 50) return true;

          return false;
        },
        function () {
          loyaltyState.sdkReady = true;
          updatePointsFromCart();
        }
      );
    }

    /* ── Handle prerendered pages (Shopify speculation rules) ── */
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', function () {
        console.log('prerenderingchange - starting loyalty polling');
        startLoyaltyPolling();
      }, { once: true });
    }

    /* ── Always start on pageshow (handles fresh loads, prerender activation,
     *    bfcache restores, and Shopify's speculation-rules navigation) ── */
    window.addEventListener('pageshow', function () {
      console.log('on pageshow start');
      startLoyaltyPolling();
    });

    /* Also start immediately for the current page load (don't wait for
     * the load event that pageshow fires after) */
    if (!document.prerendering) {
      console.log('start loyalty polling on not prerendering');
      startLoyaltyPolling();
    }

    document.addEventListener('cart:refresh', updatePointsFromCart);
    document.addEventListener('cart:updated', updatePointsFromCart);
    document.addEventListener('cart:change', updatePointsFromCart);
    document.addEventListener('loyalty:refresh', updatePointsFromCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hero-slideshow-track]');
      this.slides = Array.from(this.querySelectorAll('[data-hero-slideshow-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-slideshow-dot]'));
      this.current = 0;
      this.timer = null;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.heroSlideshowDot, 10));
          this.resetAutoplay();
        });
      });

      this._initLoopClone();
      this._scheduleDeferredImages();

      if (this.slides.length > 1 && this.dataset.autoplay === 'true') {
        this.startAutoplay();
      }

      // Swipe handling, click tracking, and the visibilitychange listener
      // only matter once the shopper actually interacts with (or leaves) the
      // page - none affect first paint, so push them past initial render to
      // shrink the one long task this above-the-fold section causes.
      const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
      this._idleHandle = idle(() => {
        this.initSwipe();
        this.initClickTracking();

        this._handleVisibilityChange = this._handleVisibilityChange.bind(this);
        document.addEventListener('visibilitychange', this._handleVisibilityChange);
      }, { timeout: 2000 });
    }

    disconnectedCallback() {
      this.stopAutoplay();
      const cancelIdle = window.cancelIdleCallback || clearTimeout;
      if (this._idleHandle) cancelIdle(this._idleHandle);
      document.removeEventListener('visibilitychange', this._handleVisibilityChange);
    }

    // Slides after the first carry their image URLs in data-src /
    // data-srcset (see the markup) so they do not compete with the LCP
    // image. They are applied once the page has loaded, or straight away
    // if a shopper swipes or taps a dot before that.
    _scheduleDeferredImages() {
      this._loadDeferredImages = () => {
        if (this._deferredImagesLoaded) return;
        this._deferredImagesLoaded = true;
        this.querySelectorAll('[data-srcset]').forEach((el) => {
          el.setAttribute('srcset', el.dataset.srcset);
          el.removeAttribute('data-srcset');
        });
        this.querySelectorAll('[data-src]').forEach((el) => {
          el.setAttribute('src', el.dataset.src);
          el.removeAttribute('data-src');
        });
      };

      if (document.readyState === 'complete') {
        setTimeout(this._loadDeferredImages, 0);
      } else {
        window.addEventListener('load', () => setTimeout(this._loadDeferredImages, 0), { once: true });
      }
    }

    _disableFocus(slide) {
      const focusable = slide.querySelectorAll(
        'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      );
      focusable.forEach((el) => el.setAttribute('tabindex', '-1'));
    }

    _enableFocus(slide) {
      const focusable = slide.querySelectorAll('[tabindex="-1"]');
      focusable.forEach((el) => el.removeAttribute('tabindex'));
    }

    _handleVisibilityChange() {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        // Force-reset to the current real slide so trackPosition can't
        // carry over a stale value (e.g. sitting on the clone) from
        // ticks that slipped through before the timer was cleared.
        this.goTo(this.current);
        if (this.slides.length > 1 && this.dataset.autoplay === 'true') {
          this.startAutoplay();
        }
      }
    }

    // The track slides via a transform driven entirely by goTo() (dots/
    // autoplay) rather than native horizontal scrolling (unlike
    // <seamless-carousel>'s overflow-x-auto track, which gets swipe for
    // free from the browser's own scroll gesture) - so swipe has to be
    // recognized manually here. touch-action: pan-y leaves vertical page
    // scrolling untouched and tells the browser this element handles
    // horizontal gestures itself; pointer events (not touch events) cover
    // touch and mouse-drag with one implementation. hasSwiped suppresses
    // the click a swipe ends on top of, so dragging across a linked slide
    // (slide_wrapper becomes <a> when banner_url is set) doesn't also
    // navigate.
    initSwipe() {
      if (!this.track || this.slides.length <= 1) return;

      const threshold = 40;
      let startX = 0;
      let startY = 0;
      let isDragging = false;
      let isHorizontal = null;
      let hasSwiped = false;

      this.track.style.touchAction = 'pan-y';

      this.track.addEventListener('dragstart', (event) => event.preventDefault());

      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        isHorizontal = null;
        startX = event.clientX;
        startY = event.clientY;
      });

      this.track.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (isHorizontal === null && (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5)) {
          isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        }
        if (isHorizontal) event.preventDefault();
      });

      const endDrag = (event) => {
        if (!isDragging) return;
        isDragging = false;
        if (!isHorizontal) return;

        const deltaX = event.clientX - startX;
        if (Math.abs(deltaX) < threshold) return;

        hasSwiped = true;
        this.goTo(this.current + (deltaX < 0 ? 1 : -1));
        this.resetAutoplay();
      };

      this.track.addEventListener('pointerup', endDrag);
      this.track.addEventListener('pointercancel', () => {
        isDragging = false;
      });

      this.track.addEventListener(
        'click',
        (event) => {
          if (!hasSwiped) return;
          hasSwiped = false;
          event.preventDefault();
        },
        true
      );
    }

    // Fires on a genuine slide click (one that's actually about to
    // navigate), not a swipe that happened to end over the link -
    // initSwipe()'s own click listener above runs first (registered on
    // this.track in the capture phase, ahead of this bubble-phase one) and
    // calls preventDefault() for a swipe-classified click, so checking
    // defaultPrevented here is enough to tell the two apart without
    // duplicating that same hasSwiped state.
    initClickTracking() {
      this.addEventListener('click', (event) => {
        if (event.defaultPrevented) return;
        if (!event.target.closest('.hero-slideshow__link[href]')) return;
        if (typeof window.trackEvent === 'function') {
          window.trackEvent('hero_banner_click', { category: 'Clickout' });
        }
      });
    }

    // Appends a clone of the first slide to the end of the track so
    // autoplay can always animate a continuous leftward slide, even when
    // wrapping from the last slide back to the first - without this, that
    // one transition would translateX() straight back to 0%, an instant
    // jump the opposite direction instead of a continuous slide left.
    // trackPosition is the raw, ever-increasing position driving the
    // transform (it can reach slides.length, landing on this clone),
    // while `current` stays a normal 0-based real-slide index for
    // dots/aria-hidden. _settleLoopClone() then snaps (no transition)
    // back to the real slide 0 at that same visual position once the
    // transition lands on the clone - invisible, since the clone is
    // byte-identical to it.
    _initLoopClone() {
      if (!this.track || this.slides.length <= 1) return;
      this.cloneSlide = this.slides[0].cloneNode(true);
      this.cloneSlide.setAttribute('aria-hidden', 'true');
      this._disableFocus(this.cloneSlide);
      this.track.appendChild(this.cloneSlide);
      this.trackPosition = 0;

      this.track.addEventListener('transitionend', (event) => {
        if (event.target === this.track && event.propertyName === 'transform') {
          this._settleLoopClone();
        }
      });
    }

    _settleLoopClone() {
      if (!this.cloneSlide || this.trackPosition < this.slides.length) return;
      const previousTransition = this.track.style.transition;
      this.track.style.transition = 'none';
      this.trackPosition = 0;
      this.track.style.transform = `translateX(-${this.trackPosition * 100}%)`;
      // Forces layout so the transition-less jump above is actually
      // painted before re-enabling transitions below, otherwise the
      // browser can coalesce both into one frame and animate the jump.
      void this.track.offsetHeight;
      this.track.style.transition = previousTransition;
    }

    // Direct jump (dots, swipe) - always goes straight to the target
    // index, in whichever direction is shorter, same as before. Only
    // autoplay's forward progression (_advanceAutoplay) needs the
    // seamless always-left loop treatment.
    goTo(index) {
      if (!this.slides.length) return;
      if (this._loadDeferredImages) this._loadDeferredImages();
      const nextIndex = (index + this.slides.length) % this.slides.length;

      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this._disableFocus(this.slides[this.current]);
      this.dots[this.current] && this.dots[this.current].classList.remove('is-active');

      this.current = nextIndex;
      this.trackPosition = nextIndex;

      this.slides[this.current].removeAttribute('aria-hidden');
      this._enableFocus(this.slides[this.current]);
      this.dots[this.current] && this.dots[this.current].classList.add('is-active');

      if (this.track) {
        this.track.style.transform = `translateX(-${this.trackPosition * 100}%)`;
      }
    }

    _advanceAutoplay() {
      if (!this.slides.length) return;
      if (this._loadDeferredImages) this._loadDeferredImages();

      // Failsafe: if transitionend didn't fire (e.g. background tab throttling
      // didn't trigger visibilitychange but stopped rendering), force settle before advancing.
      if (this.trackPosition >= this.slides.length) {
        this._settleLoopClone();
      }

      const nextIndex = (this.current + 1) % this.slides.length;

      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this._disableFocus(this.slides[this.current]);
      this.dots[this.current] && this.dots[this.current].classList.remove('is-active');

      this.current = nextIndex;
      // Hard clamp: trackPosition can never exceed slides.length (the clone),
      // so translateX is bounded to -(slides.length * 100)% at most.
      this.trackPosition = Math.min(this.trackPosition + 1, this.slides.length);

      this.slides[this.current].removeAttribute('aria-hidden');
      this._enableFocus(this.slides[this.current]);
      this.dots[this.current] && this.dots[this.current].classList.add('is-active');

      if (this.track) {
        this.track.style.transform = `translateX(-${this.trackPosition * 100}%)`;
      }
    }

    startAutoplay() {
      if (this.timer) this.stopAutoplay();
      const speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.timer = setInterval(() => this._advanceAutoplay(), speed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    resetAutoplay() {
      if (!this.timer) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  class InstagramFeed extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('[data-feed-container]');
      if (!this.container) return;

      // Use Intersection Observer to only load when the section is near the viewport
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.observer.disconnect();
          this.fetchInstagramData();
        }
      }, { rootMargin: '200px' });

      this.observer.observe(this);
    }

    async fetchInstagramData() {
      const CACHE_KEY = 'ig_feed_cache';
      const CACHE_TTL = 15 * 60 * 1000; // 15 minutes

      try {
        const cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) {
          const { data, ts } = JSON.parse(cached);
          if (Date.now() - ts < CACHE_TTL && data && data.length > 0) {
            this.renderFeed(data);
            return;
          }
        }
      } catch (e) {
        // sessionStorage may be unavailable (private browsing, etc.)
      }

      try {
        const res = await fetch('https://s-app.cocoandeve.com/instagram/feed');
        if (!res.ok) return;
        const body = await res.json();

        if (body.errors) return;

        if (body && body.length > 0) {
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: body, ts: Date.now() }));
          } catch (e) {
            // Silently fail if storage is full or unavailable
          }
          this.renderFeed(body);
        }
      } catch (err) {
        console.error('Error fetching Instagram data:', err);
      }
    }

    renderFeed(data) {
      const latestData = data.slice(0, 9).map((d, i) => {
        let image = (i === 0) 
          ? (d.thumbnail_640_url || '').replace(/\.(jpg|png)/i, '_327x327_crop_center.$1') 
          : (d.thumbnail_url || '').replace(/\.(jpg|png)/i, '_240x240_crop_center.$1');
          
        if (d.thumbnail_640_url && !d.thumbnail_640_url.includes('cdn.shopify')) {
          image = d.thumbnail_640_url;
        }

        const imageMobile = (d.thumbnail_640_url && d.thumbnail_640_url.includes('cdn.shopify')) 
          ? d.thumbnail_640_url.replace(/\.(jpg|png)/i, '_252x252_crop_center.$1') 
          : d.thumbnail_640_url;

        return {
          link: d.permalink,
          image,
          imageMobile,
        };
      });

      if (latestData.length === 0) return;

      let html = '';

      // Main first image
      html += `
        <div class="w-full hidden xl:block">
          <a href="${latestData[0].link}" target="_blank" title="Opens in a new window" class="block instagram--feed--link h-full" aria-label="Visit Instagram profile">
            <picture>
              <source srcset="${latestData[0].image}" media="(min-width: 992px)" />
              <img class="w-full aspect-square object-cover h-full" src="${latestData[0].imageMobile}" alt="Instagram highlight" loading="lazy" decoding="async" width="327" height="327" />
            </picture>
          </a>
        </div>
      `;

      // Sub-grid
      let gridHtml = '<div class="w-full grid grid-cols-2 md:grid-cols-4 gap-g md:gap-[.5rem]">';
      latestData.forEach((item, index) => {
        const visibilityClass = (index === 0) ? 'lg:hidden' : (index > 3 ? 'hidden lg:block' : '');
        
        gridHtml += `
          <div class="w-full p-0 ${visibilityClass}">
            <a href="${item.link}" target="_blank" title="Opens in a new window" class="block instagram--feed--link" aria-label="Visit Instagram profile">
              <picture>
                <source srcset="${item.image}" media="(min-width: 992px)" />
                <img class="w-full aspect-square object-cover" src="${item.imageMobile}" alt="Instagram image ${index + 1}" loading="lazy" decoding="async" width="165" height="165" />
              </picture>
            </a>
          </div>
        `;
      });
      gridHtml += '</div>';

      html += gridHtml;
      
      this.container.innerHTML = html;
    }
  }

  customElements.define('instagram-feed', InstagramFeed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!document.querySelector('script[src="https://www.tiktok.com/embed.js"]')) {
      var tiktokScript = document.createElement('script');
      tiktokScript.src = 'https://www.tiktok.com/embed.js';
      tiktokScript.async = true;
      document.body.appendChild(tiktokScript);
    }
  })();
  (function () {
    var bar = document.querySelector('.reading-proggress-bar');
    var fill = bar ? bar.querySelector('.reading-proggress-bar__proggress') : null;

    if (fill) {
      var updateProgress = function () {
        var body = document.body;
        var html = document.documentElement;
        var height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        );
        var scrollFromTop = (html.scrollTop || body.scrollTop) + html.clientHeight;
        fill.style.width = ((scrollFromTop / height) * 100) + '%';
      };

      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
    }

    setTimeout(function () {
      var mainHeader = document.querySelector('#site-header');
      if (mainHeader && bar) {
        bar.classList.remove('hidden');
        mainHeader.appendChild(bar);
      }
    }, 250);
  })();

  setTimeout(function () {
    var newsletter = document.querySelector('.blog-post-grid__newsletter');
    var wrapper = document.querySelector('.newsletterWrapper');
    if (newsletter && wrapper && newsletter.parentNode !== wrapper) {
      wrapper.appendChild(newsletter);
      newsletter.classList.remove('hidden');
    }
  }, 1500);

  (function () {
    var postBanner = document.querySelector('.blog-post-banner');
    var newBannerMarkers = document.querySelectorAll('.article-new-banner');

    if (postBanner && newBannerMarkers.length > 0) {
      // Legacy compat: older articles may have this class baked directly
      // into their body HTML from before markers existed — hide those so
      // they don't show up alongside the new cloned banners.
      document.querySelectorAll('.article-banner').forEach(function (legacyBanner) {
        legacyBanner.classList.add('hidden');
      });

      if (!document.querySelector('.cloned-banner')) {
        newBannerMarkers.forEach(function (marker) {
          var clone = postBanner.cloneNode(true);
          clone.classList.remove('blog-post-banner', 'hidden');
          clone.classList.add('cloned-banner');
          marker.appendChild(clone);
        });
      }
    }
  })();

  var quickNavLinks = document.querySelectorAll('[data-quick-nav-link]');
  (function () {
    quickNavLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var href = link.getAttribute('href');
        var target = document.querySelector(href);
        if (target) {
          var top = target.getBoundingClientRect().top + window.scrollY - 175;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    var backToTop = document.querySelector('[data-back-to-top]');
    if (backToTop) {
      backToTop.addEventListener('click', function (event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      var updateBackToTopVisibility = function () {
        var pageHeight = document.body.offsetHeight;
        var windowWidth = window.innerWidth;
        var scrollTop = window.scrollY;
        var show = false;

        if (windowWidth >= 768 && pageHeight > 3600) {
          show = scrollTop > 500;
        } else if (windowWidth < 768 && pageHeight > 2560) {
          show = scrollTop > 700;
        }

        backToTop.classList.toggle('btn--show', show);
      };

      window.addEventListener('scroll', updateBackToTopVisibility, { passive: true });
      updateBackToTopVisibility();
    }
  })();

  (function () {
    var articleContent = document.querySelector('.article__content');
    if (articleContent) {
      var headings = articleContent.querySelectorAll('h1, h2, h3, h4, h5, h6');
      headings.forEach(function (heading) {
        var text = heading.textContent || '';
        var cleanText = text.replace(/[\s\u00A0\u200B-\u200D\uFEFF]/g, '');
        var hasValidImg = heading.querySelector('img[alt]:not([alt=""])');
        var hasAriaLabel = heading.hasAttribute('aria-label') && heading.getAttribute('aria-label').trim() !== '';
        
        if (cleanText === '' && !hasValidImg && !hasAriaLabel) {
          heading.setAttribute('aria-hidden', 'true');
        }
      });

      var links = articleContent.querySelectorAll('a[href]');
      links.forEach(function (link) {
        var text = link.textContent || '';
        var cleanText = text.replace(/[\s\u00A0\u200B-\u200D\uFEFF]/g, '');
        var hasValidImg = link.querySelector('img[alt]:not([alt=""])');
        var hasAriaLabel = link.hasAttribute('aria-label') && link.getAttribute('aria-label').trim() !== '';
        
        if (cleanText === '' && !hasValidImg && !hasAriaLabel) {
          var img = link.querySelector('img');
          if (img) {
            // link.setAttribute('aria-label', 'Image link');
          } else {
            link.setAttribute('aria-hidden', 'true');
            link.setAttribute('tabindex', '-1');
          }
        }
      });

      // Iframes present in the article HTML are titled server-side. These are
      // the ones that aren't: third-party embed scripts (TikTok, Instagram,
      // Facebook) replace a <blockquote> with an iframe well after this runs,
      // so a single pass at load time misses them entirely. Title what's here
      // now, then watch for whatever gets injected later.
      var EMBED_LABELS = [
        { match: 'tiktok.com', label: 'TikTok video' },
        { match: 'youtube.com', label: 'YouTube video' },
        { match: 'youtu.be', label: 'YouTube video' },
        { match: 'instagram.com', label: 'Instagram post' },
        { match: 'facebook.com', label: 'Facebook post' },
        { match: 'vimeo.com', label: 'Vimeo video' },
        { match: 'spotify.com', label: 'Spotify player' }
      ];

      var titleForIframe = function (iframe) {
        // The embed's own iframe often has no src yet at insertion time, so the
        // original blockquote's cite URL is the more reliable hint of the two.
        var quote = iframe.closest ? iframe.closest('blockquote[cite]') : null;
        var cite = quote ? quote.getAttribute('cite') || '' : '';
        var haystack = (iframe.getAttribute('src') || '') + ' ' + cite;
        var label = 'Embedded content';

        for (var i = 0; i < EMBED_LABELS.length; i++) {
          if (haystack.indexOf(EMBED_LABELS[i].match) !== -1) {
            label = EMBED_LABELS[i].label;
            break;
          }
        }

        // e.g. https://www.tiktok.com/@darceysimmons_/video/700032... -> the
        // handle, so two embeds in one article don't share a name.
        var handle = cite.match(/@[^/?#]+/);
        if (handle) {
          label += ' by ' + handle[0];
        }

        return label;
      };

      var titleIframe = function (iframe) {
        if (!iframe.hasAttribute('title') || iframe.getAttribute('title').trim() === '') {
          iframe.setAttribute('title', titleForIframe(iframe));
        }
      };

      var titleIframesIn = function (node) {
        if (!node || node.nodeType !== 1) return;
        if (node.tagName === 'IFRAME') titleIframe(node);
        if (node.querySelectorAll) {
          node.querySelectorAll('iframe').forEach(titleIframe);
        }
      };

      titleIframesIn(articleContent);

      if (window.MutationObserver) {
        var embedObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            Array.prototype.forEach.call(mutation.addedNodes, titleIframesIn);
          });
        });

        // childList only: setting the title is an attribute change, so the
        // observer can't retrigger itself.
        embedObserver.observe(articleContent, { childList: true, subtree: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playground"] && !Shopify.designMode) return;
  try {
    
  class PlaygroundSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-playground-track]');
      this.slides = Array.from(this.querySelectorAll('[data-playground-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-playground-dot]'));
      this.current = 0;
      this.isDesktop = window.innerWidth >= 992;
      this.isDragging = false;
      this.hasDragged = false;
      this.startX = 0;
      this.currentX = 0;
      this.dragThreshold = 50;

      // This section sits below the fold on the homepage - defer listener
      // binding and the initial goTo() (a style write) until it's actually
      // about to be scrolled into view, same pattern as real-results/
      // instagram/quiz-reward, instead of paying that cost on every load.
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.setup();
            this.observer.disconnect();
          }
        },
        { rootMargin: '200px' }
      );
      this.observer.observe(this);
    }

    setup() {
      this.pointerDownHandler = this.onPointerDown.bind(this);
      this.pointerMoveHandler = this.onPointerMove.bind(this);
      this.pointerUpHandler = this.onPointerUp.bind(this);

      this.track.addEventListener('pointerdown', this.pointerDownHandler);
      this.track.addEventListener('pointermove', this.pointerMoveHandler);
      this.track.addEventListener('pointerup', this.pointerUpHandler);
      this.track.addEventListener('pointercancel', this.pointerUpHandler);
      this.track.addEventListener('pointerleave', this.pointerUpHandler);

      // Prevent default drag behaviors on the track
      this.track.addEventListener('dragstart', (e) => e.preventDefault());

      // Prevent link clicks if the user was dragging
      this.track.addEventListener('click', (e) => {
        if (this.hasDragged) {
          e.preventDefault();
        }
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.playgroundDot, 10));
        });
      });

      this.resizeHandler = this.onResize.bind(this);
      window.addEventListener('resize', this.resizeHandler);

      this.init();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
    }

    onResize() {
      const isDesktopNow = window.innerWidth >= 992;
      if (this.isDesktop !== isDesktopNow) {
        this.isDesktop = isDesktopNow;
        this.init();
      }
    }

    init() {
      if (this.isDesktop) {
        this.goTo(0);
      } else {
        if (this.track) {
          this.track.style.transform = '';
        }
        this.dots.forEach((dot) => dot.classList.remove('is-active'));
      }
    }

    goTo(index) {
      if (!this.isDesktop || !this.slides.length) return;
      const nextIndex = (index + this.slides.length) % this.slides.length;

      this.current = nextIndex;

      this.dots.forEach((dot, i) => {
        if (i === this.current) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.removeAttribute('aria-current');
        }
      });

      if (this.track) {
        this.track.style.transform = `translateX(-${this.current * 100}%)`;
      }
    }

    onPointerDown(e) {
      if (!this.isDesktop || this.slides.length <= 1) return;
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.clientX;
      this.currentX = this.startX;
      this.track.style.transition = 'none';
    }

    onPointerMove(e) {
      if (!this.isDragging) return;
      this.currentX = e.clientX;
      const diff = this.currentX - this.startX;
      if (Math.abs(diff) > 5) {
        this.hasDragged = true;
      }
      const slideWidth = this.slides[0].offsetWidth;
      const baseTranslate = -(this.current * slideWidth);
      this.track.style.transform = `translateX(${baseTranslate + diff}px)`;
    }

    onPointerUp(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.transition = '';

      const diff = this.currentX - this.startX;
      if (Math.abs(diff) > this.dragThreshold) {
        if (diff < 0) {
          this.goTo(this.current + 1);
        } else {
          this.goTo(this.current - 1);
        }
      } else {
        this.goTo(this.current); // snap back
      }
    }
  }

  customElements.define('playground-slideshow', PlaygroundSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-tabs"]) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-collection-tabs-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-collection-tabs-panel]'));
      this.bannerPanels = Array.from(this.querySelectorAll('[data-banner-slider-tabs-panel]'));
      this.shopAllLinks = Array.from(this.querySelectorAll('[data-shop-all-link]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.collectionTabsTab));
      });

      // Set initial Shop All href from the first active panel
      this.updateShopAllLink(this.panels.find((p) => !p.classList.contains('hidden')));
    }

    selectTab(key) {
      this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.collectionTabsTab === key));
      this.panels.forEach((panel) => panel.classList.toggle('hidden', panel.dataset.collectionTabsPanel !== key));
      this.bannerPanels.forEach((panel) => panel.classList.toggle('hidden', panel.dataset.bannerSliderTabsPanel !== key));

      const activePanel = this.panels.find((p) => p.dataset.collectionTabsPanel === key);
      this.updateShopAllLink(activePanel);
    }

    updateShopAllLink(panel) {
      if (!panel) return;
      const url = panel.dataset.collectionUrl;
      if (url) {
        this.shopAllLinks.forEach((link) => (link.href = url));
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-comparison').forEach(function (root) {
    var slides = Array.from(root.querySelectorAll('[data-compare-slide]'));
    if (!slides.length) return;

    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('[data-carousel-dot]')) : [];
    var track = root.querySelector('[data-carousel-track]');

    function applyValues(raw) {
      var values;
      try {
        values = JSON.parse(raw);
      } catch (e) {
        return;
      }
      Object.keys(values).forEach(function (key) {
        root.querySelectorAll('[data-compare-value="' + key + '"]').forEach(function (cell) {
          cell.textContent = values[key];
        });
      });
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('opacity-100', i === index);
        dot.classList.toggle('opacity-60', i !== index);
      });
    }

    applyValues(slides[0].dataset.compareValues);
    setActiveDot(0);

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var target = slides[index];
        if (target && track) {
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            applyValues(entry.target.dataset.compareValues);
            var index = slides.indexOf(entry.target);
            setActiveDot(index);
          }
        });
      },
      { root: track, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });

    // Desktop mouse click-and-drag scrolling — overflow-x-auto alone
    // only gives native scroll via touch swipe or an actual scrollbar
    // drag, not a mouse click-drag. Same pattern as
    // blocks/product-side-article.liquid.
    if (track) {
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;
      var startIndex = 0;
      var currentDeltaX = 0;
      var dragThreshold = 50;

      function currentSlideIndex() {
        var closest = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, i) {
          var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        return closest;
      }

      function goToSlide(index) {
        var clamped = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[clamped].offsetLeft, behavior: 'smooth' });
      }

      track.addEventListener('mousedown', function (event) {
        event.preventDefault();
        isDown = true;
        currentDeltaX = 0;
        startX = event.pageX;
        startScrollLeft = track.scrollLeft;
        startIndex = currentSlideIndex();
        track.classList.add('is-dragging');
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');

        // Always land exactly on the slide we started on, the next
        // one, or the previous one - never wherever the raw drag
        // distance happened to leave scrollLeft, which could land
        // mid-slide or on the wrong slide with a fast/short drag.
        if (Math.abs(currentDeltaX) > dragThreshold) {
          goToSlide(startIndex + (currentDeltaX < 0 ? 1 : -1));
        } else {
          goToSlide(startIndex);
        }
      });

      window.addEventListener('mousemove', function (event) {
        if (!isDown) return;
        event.preventDefault();
        currentDeltaX = event.pageX - startX;
        track.scrollLeft = startScrollLeft - currentDeltaX;
      });

      // A plain `click` still fires on whatever's under the cursor at
      // mouseup regardless of how far the drag traveled - without this,
      // releasing a drag over a slide silently navigates to it.
      track.addEventListener('click', function (event) {
        if (Math.abs(currentDeltaX) > 5) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-review-tabs')) {
  customElements.define('product-review-tabs', class ProductReviewTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.yotpo-tab-btn');

      this.activeClasses = ['instagram-reels__nav--active', 'lg:bg-dark', 'lg:text-white', 'lg:hover:text-white', 'border-b-2', 'nav--active', 'font-normal'];
      this.inactiveClasses = ['text-gray-600', 'hover:text-primary'];

      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          const target = e.currentTarget;

          // Remove active classes from all tabs
          this.tabs.forEach(t => {
            t.classList.remove(...this.activeClasses);
            t.classList.add(...this.inactiveClasses);
          });

          // Add active classes to clicked tab
          target.classList.remove(...this.inactiveClasses);
          target.classList.add(...this.activeClasses);

          // Also update the main product-review-root if present
          const reviewRoot = document.getElementById('product-review-root');
          if (reviewRoot) {
            reviewRoot.setAttribute('data-product-skus', target.getAttribute('data-skus'));

            // Dispatch a custom event so React can optionally listen and re-render
            window.dispatchEvent(new CustomEvent('product-review-skus-updated', {
              detail: { skus: target.getAttribute('data-skus') }
            }));
          }
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-product-tabs-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-product-tabs-panel]'));
      this.requests = {};

      this.tabs.forEach((tab) => {
        const key = tab.dataset.productTabsTab;
        tab.addEventListener('click', () => this.selectTab(key));
        // Start fetching a deferred panel as soon as intent shows, so the
        // click itself rarely waits on the network.
        tab.addEventListener('pointerenter', () => this.loadPanel(key), { once: true });
        tab.addEventListener('focus', () => this.loadPanel(key), { once: true });
      });

      // Prefetch the deferred panels once the page is idle after load -
      // late enough not to touch FCP/LCP, early enough that a shopper
      // rarely sees an empty tab.
      const prefetch = () => {
        const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
        idle(() => this.panels.forEach((panel) => this.loadPanel(panel.dataset.productTabsPanel)));
      };
      if (document.readyState === 'complete') {
        prefetch();
      } else {
        window.addEventListener('load', prefetch, { once: true });
      }
    }

    selectTab(key) {
      this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.productTabsTab === key));
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.productTabsPanel === key;
        panel.classList.toggle('hidden', !isActive);

        if (isActive) {
          // Cards in this panel skipped their rating fetch while it was
          // hidden (src/scripts/product-card.js initReviewStars) - now that
          // a shopper has switched to it, hydrate them. The data-rating-init
          // guard makes switching back to an already-hydrated tab a no-op.
          document.dispatchEvent(new CustomEvent('product-cards:added', { detail: { root: panel } }));
        }
      });
      this.loadPanel(key);
    }

    // Fetches a deferred panel (lazy_load_hidden_tabs) once. No-op for
    // panels rendered server-side (no data-product-tabs-url).
    loadPanel(key) {
      const panel = this.panels.find((p) => p.dataset.productTabsPanel === key);
      if (!panel || !panel.dataset.productTabsUrl || this.requests[key]) return this.requests[key];

      const url = new URL(panel.dataset.productTabsUrl, window.location.origin);
      url.searchParams.set('view', 'tab-panel');
      const limit = parseInt(panel.dataset.productTabsLimit, 10) || 24;

      panel.setAttribute('aria-busy', 'true');
      this.requests[key] = fetch(url.toString(), { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Product tabs: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const carousel = doc.querySelector('seamless-carousel');
          if (!carousel) return;
          // collection.tab-panel renders up to the schema maximum (it can't
          // read this section's settings); trim to this tab's own limit.
          const cards = carousel.querySelectorAll('[data-carousel-track] > .product-card');
          Array.from(cards).slice(limit).forEach((card) => card.remove());
          // Inserting upgrades <seamless-carousel> (connectedCallback runs);
          // card clicks use delegated listeners, so nothing to re-bind.
          panel.replaceChildren(document.importNode(carousel, true));
          // Swatch colours, badge text alignment and (if this panel is
          // visible) review stars are applied by product-card.js to
          // elements directly - run that pass over the new cards.
          document.dispatchEvent(new CustomEvent('product-cards:added', { detail: { root: panel } }));
        })
        .catch(() => {
          // Let a later click retry instead of caching the failure.
          delete this.requests[key];
        })
        .finally(() => panel.removeAttribute('aria-busy'));

      return this.requests[key];
    }
  }

  customElements.define('product-tabs', ProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-reward"] && !Shopify.designMode) return;
  try {
    
  class QuizReward extends HTMLElement {
    constructor() {
      super();
      this.initOSDetection();
      this.initIntersectionObserver();
    }

    initOSDetection() {
      if (window.isAppleOS && window.isAppleOS()) {
        this.querySelectorAll('.quiz-reward-text').forEach((el) => {
          el.classList.add('relative', 'top-[1px]');
        });
      }
    }

    initIntersectionObserver() {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.fetchReviews();
            observer.disconnect();
          }
        },
        { rootMargin: '200px' }
      );
      observer.observe(this);
    }

    async fetchReviews() {
      const apiUrl = 'https://reviews-api.cocoandeve.com/api';
      const headers = {};

      while (typeof window.encryptParam !== 'function') {
        await new Promise(resolve => setTimeout(resolve, 50));
      }

      headers['signature'] = window.encryptParam(`{brand:'cocoandeve',time:${new Date().getTime()}}`);

      try {
        const res = await fetch(`${apiUrl}/reviews/total.json?brand=cocoandeve`, { headers });
        const data = await res.json();
        const total = data?.response?.total_reviews;
        if (total) {
          const reviewsEls = this.querySelectorAll('.quiz-reward-reviews');
          reviewsEls.forEach((el) => {
            el.textContent = `${total.toLocaleString()} customer reviews`;
            el.classList.remove('hidden');
          });
        }
      } catch (err) {
        console.error('Error fetching total reviews', err);
      }
    }
  }

  if (!customElements.get('quiz-reward')) {
    customElements.define('quiz-reward', QuizReward);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-results-tabs"] && !Shopify.designMode) return;
  try {
    
  class RealResultsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-real-results-tabs-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-real-results-tabs-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.realResultsTabsTab));
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const media = entry.target.querySelector('[data-real-results-tabs-media]');
            if (!media) return;
            if (entry.isIntersecting) {
              this.play(media);
            } else {
              this.pause(media);
            }
          });
        },
        { rootMargin: '200px', threshold: 0.1 }
      );
      this.querySelectorAll('[data-real-results-tabs-card]').forEach((card) => this.observer.observe(card));

      // Mobile fake scrollbar - same thumb-width/position formula as
      // blocks/product-accordion.liquid's own proud-to-be-scrollbar, plus
      // the thumb itself is draggable (product-accordion's is not - that
      // one only supports dragging the list, since it has no arrow buttons
      // at all; this one already has real desktop arrows, so the mobile
      // scrollbar's own job is just to double as a drag handle).
      this.querySelectorAll('[data-carousel-track]').forEach((track) => {
        const bar = track.closest('[data-real-results-tabs-panel]')?.querySelector('.real-results-tabs__scrollbar');
        const thumb = bar?.querySelector('[data-real-results-tabs-thumb]');
        if (!bar || !thumb) return;

        const updateThumb = () => {
          const overflow = track.scrollWidth - track.offsetWidth;
          const thumbWidth = Math.min(100, (track.offsetWidth / track.scrollWidth) * 100);
          const progress = overflow > 0 ? track.scrollLeft / overflow : 0;
          thumb.style.width = `${thumbWidth}%`;
          thumb.style.left = `${progress * (100 - thumbWidth)}%`;
        };
        track.addEventListener('scroll', updateThumb);
        window.addEventListener('resize', updateThumb);
        updateThumb();

        // Drag the handle itself to scroll - pointer position mapped from
        // the bar's own pixel width (minus the thumb's width, its actual
        // travel range) onto the track's scrollLeft range (its overflow).
        let dragStartX = 0;
        let dragStartScrollLeft = 0;

        const onPointerMove = (event) => {
          const travel = bar.offsetWidth - thumb.offsetWidth;
          if (travel <= 0) return;
          const overflow = track.scrollWidth - track.offsetWidth;
          const deltaX = event.clientX - dragStartX;
          track.scrollLeft = dragStartScrollLeft + (deltaX / travel) * overflow;
        };
        const onPointerUp = (event) => {
          thumb.releasePointerCapture(event.pointerId);
          thumb.removeEventListener('pointermove', onPointerMove);
          thumb.removeEventListener('pointerup', onPointerUp);
          thumb.removeEventListener('pointercancel', onPointerUp);
        };

        thumb.addEventListener('pointerdown', (event) => {
          dragStartX = event.clientX;
          dragStartScrollLeft = track.scrollLeft;
          thumb.setPointerCapture(event.pointerId);
          thumb.addEventListener('pointermove', onPointerMove);
          thumb.addEventListener('pointerup', onPointerUp);
          thumb.addEventListener('pointercancel', onPointerUp);
        });
      });
    }

    disconnectedCallback() {
      this.observer && this.observer.disconnect();
    }

    // The <video> is only built once the card is actually near the viewport, so
    // a card in a hidden panel never costs a byte of video payload. Switching
    // tabs un-hides its panel, which makes those cards intersect and load.
    play(media) {
      let video = media.querySelector('video');

      if (!video) {
        if (!media.dataset.videoSrc) return;

        const poster = media.querySelector('img');
        video = document.createElement('video');
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        video.preload = 'none';
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        if (poster) video.poster = poster.currentSrc || poster.src;

        const source = document.createElement('source');
        source.src = media.dataset.videoSrc;
        if (media.dataset.videoType) source.type = media.dataset.videoType;
        video.appendChild(source);

        video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
        media.appendChild(video);
      }

      video.play().catch(() => {});
    }

    pause(media) {
      const video = media.querySelector('video');
      if (video) video.pause();
    }

    selectTab(key) {
      this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.realResultsTabsTab === key));
      this.panels.forEach((panel) => panel.classList.toggle('hidden', panel.dataset.realResultsTabsPanel !== key));
    }
  }

  customElements.define('real-results-tabs', RealResultsTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-results"] && !Shopify.designMode) return;
  try {
    
  class RealResults extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-real-results-tab]'));
      this.cards = Array.from(this.querySelectorAll('[data-real-results-card]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.realResultsTab));
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const media = entry.target.querySelector('[data-real-results-media]');
            if (!media) return;
            if (entry.isIntersecting) {
              this.play(media);
            } else {
              this.pause(media);
            }
          });
        },
        { rootMargin: '200px', threshold: 0.1 }
      );
      this.cards.forEach((card) => this.observer.observe(card));

      if (this.tabs.length > 0) {
        this.selectTab(this.tabs[0].dataset.realResultsTab);
      } else {
        let shown = 0;
        this.cards.forEach((card) => {
          const visible = shown < 4;
          if (visible) shown++;
          card.classList.toggle('is-hidden', !visible);
        });
      }
    }

    disconnectedCallback() {
      this.observer && this.observer.disconnect();
    }

    // The <video> is only built once the card is actually near the viewport, so
    // an off-screen or non-selected card never costs a byte of video payload.
    play(media) {
      let video = media.querySelector('video');

      if (!video) {
        if (!media.dataset.videoSrc) return;

        const poster = media.querySelector('img');
        video = document.createElement('video');
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        video.preload = 'none';
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        if (poster) video.poster = poster.currentSrc || poster.src;

        const source = document.createElement('source');
        source.src = media.dataset.videoSrc;
        if (media.dataset.videoType) source.type = media.dataset.videoType;
        video.appendChild(source);

        video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
        media.appendChild(video);
      }

      video.play().catch(() => {});
    }

    pause(media) {
      const video = media.querySelector('video');
      if (video) video.pause();
    }

    selectTab(category) {
      this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.realResultsTab === category));

      let shown = 0;
      this.cards.forEach((card) => {
        const categories = (card.dataset.realResultsCategories || '').split(' ');
        const matches = categories.includes(category);
        const visible = matches && shown < 4;
        if (visible) shown++;
        card.classList.toggle('is-hidden', !visible);
      });
    }
  }

  customElements.define('real-results', RealResults);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailers"] && !Shopify.designMode) return;
  try {
    
  class RetailersPage extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-retailers-region-select]');
      this.items = Array.from(this.querySelectorAll('[data-retailers-item]'));
      this.regionTitle = this.querySelector('[data-retailers-region-title]');

      if (this.select) {
        this.select.addEventListener('change', () => this.render());
      }

      this.render();
    }

    render() {
      if (!this.select || this.select.options.length === 0) return;

      const region = this.select.value;
      const label = this.select.options[this.select.selectedIndex] ? this.select.options[this.select.selectedIndex].text : '';

      if (this.regionTitle) this.regionTitle.textContent = label;

      this.items.forEach((item) => {
        const regions = (item.dataset.regions || '').split(',').map((r) => r.trim()).filter(Boolean);
        item.classList.toggle('hidden', !regions.includes(region));
      });
    }
  }

  customElements.define('retailers-page', RetailersPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-grid"] && !Shopify.designMode) return;
  try {
    
  class ReviewsGrid extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-reviews-grid-tab]'));
      this.cards = Array.from(this.querySelectorAll('[data-real-result-card]'));
      this.showMoreWrap = this.querySelector('[data-reviews-grid-show-more]');
      this.showMoreBtn = this.querySelector('[data-reviews-grid-show-more-btn]');

      this.perPageDesktop = parseInt(this.dataset.perPageDesktop, 10) || 9;
      this.perPageMobile = parseInt(this.dataset.perPageMobile, 10) || 6;
      this.perPage = window.innerWidth >= 992 ? this.perPageDesktop : this.perPageMobile;

      this.activeTab = 'all';
      this.visibleCount = this.perPage;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activeTab = tab.dataset.reviewsGridTab;
          this.visibleCount = this.perPage;
          this.tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          this.render();
        });
      });

      if (this.showMoreBtn) {
        this.showMoreBtn.addEventListener('click', () => {
          this.visibleCount += this.perPage;
          this.render();
        });
      }

      this.querySelectorAll('.result-card__toggle').forEach((btn) => {
        btn.addEventListener('click', () => {
          const wrap = btn.closest('p');
          const short = wrap.querySelector('.result-card__short');
          const full = wrap.querySelector('.result-card__full');
          const ellipsis = wrap.querySelector('.result-card__ellipsis');
          const expanded = btn.dataset.state === 'full';

          short.classList.toggle('hidden', !expanded);
          full.classList.toggle('hidden', expanded);
          if (ellipsis) ellipsis.classList.toggle('hidden', !expanded);
          btn.dataset.state = expanded ? 'short' : 'full';
          btn.textContent = expanded ? 'Read more' : 'Read less';
        });
      });

      this.render();
    }

    matches(card, tab) {
      if (tab === 'all') return true;
      const types = (card.dataset.types || '').trim().split(/\s+/);
      return types.includes(tab);
    }

    render() {
      let shown = 0;
      this.cards.forEach((card) => {
        const isMatch = this.matches(card, this.activeTab);
        const visible = isMatch && shown < this.visibleCount;
        if (visible) shown += 1;
        card.classList.toggle('is-hidden', !visible);
      });

      const totalMatching = this.cards.filter((card) => this.matches(card, this.activeTab)).length;
      if (this.showMoreWrap) {
        this.showMoreWrap.classList.toggle('is-hidden', this.visibleCount >= totalMatching);
      }
    }
  }

  customElements.define('reviews-grid', ReviewsGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-icon"] && !Shopify.designMode) return;
  try {
    
  class ServicesIcon extends HTMLElement {
    constructor() {
      super();
      this.initIntersectionObserver();
    }

    initIntersectionObserver() {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.fetchReviews();
            observer.disconnect();
          }
        },
        { rootMargin: '200px' }
      );
      observer.observe(this);
    }

    async fetchReviews() {
      const apiUrl = 'https://reviews-api.cocoandeve.com/api';

      while (typeof window.encryptParam !== 'function') {
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      const signature = window.encryptParam(`{brand:'cocoandeve',time:${new Date().getTime()}}`);

      try {
        const res = await fetch(`${apiUrl}/reviews/total.json?brand=cocoandeve`, {
          headers: { signature: signature },
        });
        const data = await res.json();
        const total = data?.response?.total_reviews;
        if (total) {
          const countEls = this.querySelectorAll('.js-reviews-count');
          countEls.forEach((el) => {
            el.innerText = total.toLocaleString();
          });
        }
      } catch (err) {
        console.error('Error fetching reviews:', err);
      }
    }
  }

  customElements.define('services-icon', ServicesIcon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-ingredient-standards"] && !Shopify.designMode) return;
  try {
    
  class IngredientTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ingredient-tabs-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-ingredient-tabs-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.ingredientTabsTab));
      });
    }

    select(key) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.ingredientTabsTab === key;
        tab.classList.toggle('is-active', isActive);
        tab.classList.toggle('bg-dark', isActive);
        tab.classList.toggle('text-white', isActive);
        tab.classList.toggle('hover:text-white', isActive);
        tab.classList.toggle('bg-white', !isActive);
        tab.classList.toggle('hover:text-primary', !isActive);
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.dataset.ingredientTabsPanel !== key);
      });
    }
  }
  customElements.define('ingredient-tabs', IngredientTabs);

  class IngredientAccordion extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(this.querySelectorAll('[data-accordion-toggle]'));
      this.openKey = this.toggles.length > 0 ? this.toggles[0].dataset.accordionToggle : null;

      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const key = toggle.dataset.accordionToggle;
          this.openKey = this.openKey === key ? null : key;
          this.render(false);
        });
      });

      this.render(true);
    }

    render(isInitial) {
      this.toggles.forEach((toggle) => {
        const key = toggle.dataset.accordionToggle;
        const isOpen = key === this.openKey;
        const content = this.querySelector('[data-accordion-content="' + key + '"]');
        const plus = toggle.querySelector('[data-accordion-icon-plus]');
        const minus = toggle.querySelector('[data-accordion-icon-minus]');

        toggle.classList.toggle('accordion-opened', isOpen);
        if (plus) plus.classList.toggle('hidden', isOpen);
        if (minus) minus.classList.toggle('hidden', !isOpen);

        if (content) {
          content.classList.toggle('accordion-content--open', isOpen);
          content.classList.toggle('accordion-content--close', !isOpen);

          if (isInitial) {
            // Skip measuring scrollHeight on first paint — it can run
            // before webfonts/layout have fully settled, producing a
            // too-small height that squishes the initially-open panel
            // until the shopper manually toggles it once. The stylesheet's
            // .accordion-content--open { max-height: 1000px } fallback is
            // generous enough to never clip real content, so just let the
            // CSS classes above handle the initial open state.
          } else {
            content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0px';
          }
        }
      });
    }
  }
  customElements.define('ingredient-accordion', IngredientAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timer-bar"] && !Shopify.designMode) return;
  try {
    
  class TimerBarCountdown extends HTMLElement {
    connectedCallback() {
      this.startAt = this.dataset.startAt;
      this.endAt = this.dataset.endAt;
      this.labelFormat = this.dataset.labelFormat || 'Day,Days:Hour,Hours:Minutes:Seconds';

      this.elDays = this.querySelector('[data-timer-days]');
      this.elHours = this.querySelector('[data-timer-hours]');
      this.elMinutes = this.querySelector('[data-timer-minutes]');
      this.elSeconds = this.querySelector('[data-timer-seconds]');
      this.elList = this.querySelector('[data-countdown-list]');

      this.parseLabels();
      this.initTimer();
    }

    parseLabels() {
      // Expected format: "Day,Days:Hour,Hours:Minutes:Seconds"
      const parts = this.labelFormat.split(':');
      const dayParts = parts[0] ? parts[0].split(',') : ['Day', 'Days'];
      const hourParts = parts[1] ? parts[1].split(',') : ['Hour', 'Hours'];

      this.labelDaySingular = dayParts[0] || 'Day';
      this.labelDayPlural = dayParts[1] || 'Days';
      this.labelHourSingular = hourParts[0] || 'Hour';
      this.labelHourPlural = hourParts[1] || 'Hours';
      this.labelMinutes = parts[2] || 'Minutes';
      this.labelSeconds = parts[3] || 'Seconds';
    }

    getUtcTime(date) {
      const d = new Date(date);
      const utc = Date.UTC(
        d.getUTCFullYear(),
        d.getUTCMonth(),
        d.getUTCDate(),
        d.getUTCHours(),
        d.getUTCMinutes(),
        d.getUTCSeconds(),
        d.getUTCMilliseconds()
      );
      return utc - 8 * 60 * 60 * 1000;
    }

    nowUtcTime() {
      const now = new Date();
      const utc = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds(),
        now.getUTCMilliseconds()
      );
      return utc - 8 * 60 * 60 * 1000;
    }

    initTimer() {
      const startAt = this.getUtcTime(this.startAt);
      const endAt = this.getUtcTime(this.endAt);
      const now = this.nowUtcTime();

      if (now > startAt && now < endAt) {
        this.show();
        this.startCountdown(this.endAt);
      }
    }

    show() {
      this.classList.remove('hidden');
      document.body.classList.add('timer-bar--show');
      // Only offset the header when the timer bar is sticky (position: fixed)
      if (this.hasAttribute('data-sticky')) {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--timer-bar-height', this.getBoundingClientRect().height + 'px');
          // Announcement bar is hidden when timer is active, so zero its height
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        });
      }
    }

    hide() {
      this.classList.add('hidden');
      document.body.classList.remove('timer-bar--show');
      document.documentElement.style.setProperty('--timer-bar-height', '0px');
    }

    startCountdown(endAt) {
      const end = new Date(endAt);
      const SECOND = 1000;
      const MINUTE = SECOND * 60;
      const HOUR = MINUTE * 60;
      const DAY = HOUR * 24;

      const tick = () => {
        const now = new Date();
        const distance = end - now;

        if (distance < 0) {
          clearInterval(this.timer);
          this.hide();
          return;
        }

        const days = Math.floor(distance / DAY);
        const hours = Math.floor((distance % DAY) / HOUR);
        const minutes = Math.floor((distance % HOUR) / MINUTE);
        const seconds = Math.floor((distance % MINUTE) / SECOND);

        // Days
        if (days > 0) {
          const dayLabel = days > 1 ? this.labelDayPlural : this.labelDaySingular;
          this.elDays.innerHTML = `\u00a0${days}\u00a0\u00a0<span>${dayLabel}\u00a0</span>`;
          this.elDays.classList.remove('hidden');
        } else {
          this.elDays.innerHTML = '';
          this.elDays.classList.add('hidden');
        }

        // Hours
        const hourLabel = hours > 1 ? this.labelHourPlural : this.labelHourSingular;
        this.elHours.innerHTML = `\u00a0${String(hours).padStart(2, '0')}\u00a0\u00a0<span>${hourLabel}\u00a0</span>`;

        // Minutes
        this.elMinutes.innerHTML = `\u00a0${String(minutes).padStart(2, '0')}\u00a0\u00a0<span>${
          this.labelMinutes
        }\u00a0</span>`;

        // Seconds
        this.elSeconds.innerHTML = `\u00a0${String(seconds).padStart(2, '0')}\u00a0\u00a0<span>${
          this.labelSeconds
        }\u00a0</span>`;

        // Show the countdown list once values are populated
        this.elList.classList.remove('hidden');
        this.elList.classList.add('inline');
      };

      tick();
      this.timer = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.body.classList.remove('timer-bar--show');
    }
  }

  customElements.define('timer-bar-countdown', TimerBarCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-my-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('track-my-order')) {
    customElements.define(
      'track-my-order',
      class TrackMyOrder extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('#track-order-form');
          this.input = this.querySelector('#tracking_number');
          this.btn = this.querySelector('#track-order-btn');
          this.resultContainer = this.querySelector('#track-result-container');

          if (!this.form || !this.input || !this.btn || !this.resultContainer) return;

          this.icons = {
            trackConfirmed:
              '<svg class="text-primary h-[2em] w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><defs><style>.a{isolation:isolate;}.b{fill:#4dba86;stroke:#4dba86;stroke-width:0.3px;}</style></defs><g class="a" transform="translate(0.15 0.15)"><path class="b" d="M33.576,16.618a.592.592,0,0,0-.435-.218H22.458a.543.543,0,0,0-.435.218l-4.1,5.242a.656.656,0,0,0-.124.343V36.838a.558.558,0,0,0,.559.562H37.241a.558.558,0,0,0,.559-.562V22.2a.471.471,0,0,0-.124-.343Zm-5.217.9h4.5l3.2,4.088H28.328V17.523Zm-5.621,0h4.5v4.088H19.508ZM36.682,36.245H18.918V22.766H36.682ZM24.477,30a.586.586,0,0,1,0-.811.579.579,0,0,1,.807,0l1.46,1.467,3.571-3.588a.579.579,0,0,1,.807,0,.586.586,0,0,1,0,.811l-3.944,3.963a.513.513,0,0,1-.4.156.652.652,0,0,1-.4-.156Z" transform="translate(-17.8 -16.4)"/></g></svg>',
            trackPickup:
              '<svg class="text-primary h-[2em] w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><defs><style>.a{fill:#4dba86;stroke:#4dba86;stroke-width:0.3px;}</style></defs><path class="a" d="M24.85,28.563a.586.586,0,0,1,0-.811L27.4,25.193a.589.589,0,0,1,.4-.156.652.652,0,0,1,.4.156l2.547,2.559a.586.586,0,0,1,0,.811.579.579,0,0,1-.807,0l-1.584-1.591v6.3a.559.559,0,1,1-1.118,0v-6.3l-1.584,1.591A.579.579,0,0,1,24.85,28.563Zm12.826-6.8a.656.656,0,0,1,.124.343V36.738a.558.558,0,0,1-.559.562H18.359a.558.558,0,0,1-.559-.562V22.1a.471.471,0,0,1,.124-.343l4.1-5.242a.592.592,0,0,1,.435-.218H33.142a.543.543,0,0,1,.435.218Zm-9.317-.218h7.733l-3.2-4.088h-4.5v4.088Zm-8.851,0h7.733V17.455h-4.5ZM36.682,22.7H18.918v13.48H36.682Z" transform="translate(-17.65 -16.15)"/></svg>',
            trackPickupDisabled:
              '<svg class="text-primary h-[2em] w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><defs><style>.a{fill:#cecece;stroke:#cecece;stroke-width:0.3px;}</style></defs><path class="a" d="M24.85,28.563a.586.586,0,0,1,0-.811L27.4,25.193a.589.589,0,0,1,.4-.156.652.652,0,0,1,.4.156l2.547,2.559a.586.586,0,0,1,0,.811.579.579,0,0,1-.807,0l-1.584-1.591v6.3a.559.559,0,1,1-1.118,0v-6.3l-1.584,1.591A.579.579,0,0,1,24.85,28.563Zm12.826-6.8a.656.656,0,0,1,.124.343V36.738a.558.558,0,0,1-.559.562H18.359a.558.558,0,0,1-.559-.562V22.1a.471.471,0,0,1,.124-.343l4.1-5.242a.592.592,0,0,1,.435-.218H33.142a.543.543,0,0,1,.435.218Zm-9.317-.218h7.733l-3.2-4.088h-4.5v4.088Zm-8.851,0h7.733V17.455h-4.5ZM36.682,22.7H18.918v13.48H36.682Z" transform="translate(-17.65 -16.15)"/></svg>',
            trackTransit:
              '<svg class="text-primary h-[2em] w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 24"><defs><style>.a{fill:#4DBA86;}</style></defs><path class="a" d="M20.479,43.1h2.754a.526.526,0,0,0,.247-.041,2.871,2.871,0,0,0,5.672.041h8a2.875,2.875,0,0,0,5.672,0h2.261a.717.717,0,0,0,.7-.692V34.787a6.623,6.623,0,0,0-1.6-4.684,5.265,5.265,0,0,0-3.9-1.629h-4.11V26.192a.717.717,0,0,0-.7-.692H20.479a.717.717,0,0,0-.7.692V42.4A.717.717,0,0,0,20.479,43.1Zm19.506.978a1.466,1.466,0,1,1,1.48-1.466A1.467,1.467,0,0,1,39.985,44.074ZM36.162,29.858h4.11c2.548,0,4.11,1.874,4.11,4.888v6.925H42.7a2.935,2.935,0,0,0-2.713-1.914,2.853,2.853,0,0,0-2.713,1.914H36.2V29.858Zm-9.8,14.216a1.466,1.466,0,1,1,1.48-1.466A1.522,1.522,0,0,1,26.357,44.074ZM21.178,26.885H34.723V41.671H29.316a.526.526,0,0,0-.247.041,2.888,2.888,0,0,0-2.754-1.955,2.924,2.924,0,0,0-2.754,2,.78.78,0,0,0-.329-.081H21.178Z" transform="translate(-19.78 -25.5)"/></svg>',
            trackTransitDisabled:
              '<svg class="text-primary h-[2em] w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 24"><defs><style>.a{fill:#cecece;}</style></defs><path class="a" d="M20.479,43.1h2.754a.526.526,0,0,0,.247-.041,2.871,2.871,0,0,0,5.672.041h8a2.875,2.875,0,0,0,5.672,0h2.261a.717.717,0,0,0,.7-.692V34.787a6.623,6.623,0,0,0-1.6-4.684,5.265,5.265,0,0,0-3.9-1.629h-4.11V26.192a.717.717,0,0,0-.7-.692H20.479a.717.717,0,0,0-.7.692V42.4A.717.717,0,0,0,20.479,43.1Zm19.506.978a1.466,1.466,0,1,1,1.48-1.466A1.467,1.467,0,0,1,39.985,44.074ZM36.162,29.858h4.11c2.548,0,4.11,1.874,4.11,4.888v6.925H42.7a2.935,2.935,0,0,0-2.713-1.914,2.853,2.853,0,0,0-2.713,1.914H36.2V29.858Zm-9.8,14.216a1.466,1.466,0,1,1,1.48-1.466A1.522,1.522,0,0,1,26.357,44.074ZM21.178,26.885H34.723V41.671H29.316a.526.526,0,0,0-.247.041,2.888,2.888,0,0,0-2.754-1.955,2.924,2.924,0,0,0-2.754,2,.78.78,0,0,0-.329-.081H21.178Z" transform="translate(-19.78 -25.5)"/></svg>',
            trackDelivered:
              '<svg class="text-primary h-[2em] w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><defs><style>.a{isolation:isolate;}.b{fill:#4dba86;stroke:#4dba86;stroke-width:0.3px;}</style></defs><g class="a" transform="translate(0.15 0.15)"><path class="b" d="M33.576,16.618a.592.592,0,0,0-.435-.218H22.458a.543.543,0,0,0-.435.218l-4.1,5.242a.656.656,0,0,0-.124.343V36.838a.558.558,0,0,0,.559.562H37.241a.558.558,0,0,0,.559-.562V22.2a.471.471,0,0,0-.124-.343Zm-5.217.9h4.5l3.2,4.088H28.328V17.523Zm-5.621,0h4.5v4.088H19.508ZM36.682,36.245H18.918V22.766H36.682ZM24.477,30a.586.586,0,0,1,0-.811.579.579,0,0,1,.807,0l1.46,1.467,3.571-3.588a.579.579,0,0,1,.807,0,.586.586,0,0,1,0,.811l-3.944,3.963a.513.513,0,0,1-.4.156.652.652,0,0,1-.4-.156Z" transform="translate(-17.8 -16.4)"/></g></svg>',
            trackDeliveredDisabled:
              '<svg class="text-primary h-[2em] w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><defs><style>.a{isolation:isolate;}.b{fill:#cecece;stroke:#cecece;stroke-width:0.3px;}</style></defs><g class="a" transform="translate(0.15 0.15)"><path class="b" d="M33.576,16.618a.592.592,0,0,0-.435-.218H22.458a.543.543,0,0,0-.435.218l-4.1,5.242a.656.656,0,0,0-.124.343V36.838a.558.558,0,0,0,.559.562H37.241a.558.558,0,0,0,.559-.562V22.2a.471.471,0,0,0-.124-.343Zm-5.217.9h4.5l3.2,4.088H28.328V17.523Zm-5.621,0h4.5v4.088H19.508ZM36.682,36.245H18.918V22.766H36.682ZM24.477,30a.586.586,0,0,1,0-.811.579.579,0,0,1,.807,0l1.46,1.467,3.571-3.588a.579.579,0,0,1,.807,0,.586.586,0,0,1,0,.811l-3.944,3.963a.513.513,0,0,1-.4.156.652.652,0,0,1-.4-.156Z" transform="translate(-17.8 -16.4)"/></g></svg>',
          };

          this.form.addEventListener('submit', this.onSubmit.bind(this));

          const urlParams = new URLSearchParams(window.location.search);
          const urlNum = urlParams.get('trackingNumber');
          if (urlNum) {
            this.input.value = urlNum;
            this.fetchTrack(urlNum);
          }
        }

        onSubmit(e) {
          e.preventDefault();
          const val = this.input.value.trim();
          if (val) {
            this.fetchTrack(val);
          }
        }

        renderResult(data) {
          if (!data.fulfillment && !data.order) {
            return `
                    <div class='w-full text-center flex justify-center'>
                        <p class="no_data_message lg:max-w-[70%] text-center mb-4 lg:mb-0">We are not able to find tracking details. If you have just placed the order, please allow two business days for the order to be fulfilled. You will receive a shipping notification email once the order is shipped. Otherwise, please <a href="https://support.cocoandeve.com/en-GB" class='track-order-link text-primary hover:text-primary-darken hover:text-underline whitespace-nowrap'>contact us</a> for help.</p>
                    </div>
                `;
          }

          let trackingUrlHtml = '';
          if (data.fulfillment && data.fulfillment.tracking_url) {
            trackingUrlHtml = `
                    <h2 class="mt-2 mb-1 text-base text-center">Your Order has been picked up by our Shipping Partner.</h2>
                    <div class=' text-center  lg:mb-5'>
                        <a href="${data.fulfillment.tracking_url}" target="_blank" title="Opens in a new window" class='text-[#1c5c92] text-[20px] leading-[1.42857143]'>Click here to track your order now on our shipping partner's platform.</a>
                    </div>
                `;
          }

          const status = data.status || 'initial';

          let statusText = 'Your order has been placed successfully.';
          if (status === 'intransit') statusText = 'Your order is on its way';
          if (status === 'pickup') statusText = 'Your order has been picked up';
          if (status === 'delivered') statusText = 'Your order has been delivered';

          const trackPickupIcon = status === 'initial' ? this.icons.trackPickupDisabled : this.icons.trackPickup;
          const trackTransitIcon =
            status === 'initial' || status === 'pickup' ? this.icons.trackTransitDisabled : this.icons.trackTransit;
          const trackDeliveredIcon =
            status === 'initial' || status === 'pickup' || status === 'intransit'
              ? this.icons.trackDeliveredDisabled
              : this.icons.trackDelivered;

          let itemsHtml = '';
          if (data.fulfillment && data.fulfillment.line_items) {
            itemsHtml = data.fulfillment.line_items
              .map(
                (item) => `
                    <tr>
                        <td class='px-[10px] py-[25px] text-[#484848] bg-[#efefef] text-sm'>${item.title || ''}</td>
                        <td class='px-[10px] py-[25px] text-[#484848] bg-[#efefef] text-sm'>${item.quantity || ''}</td>
                        <td class='px-[10px] py-[25px] text-[#484848] bg-[#efefef] text-sm'>${
                          data.order ? data.order.tracking_number || '' : ''
                        }</td>
                        <td class='px-[10px] py-[25px] text-[#484848] bg-[#efefef] text-sm'>${
                          data.order ? data.order.tracking_company || '' : ''
                        }</td>
                    </tr>
                `
              )
              .join('');
          }

          const orderNumber = data.order ? data.order.order_number || '' : '';
          const statusUpper = status.toUpperCase();

          return `
                <div class='flex flex-col w-full justify-center'>
                    ${trackingUrlHtml}
                </div>
                <div class='flex flex-col w-full justify-center border-b-solid lg:border-b-[1px] border-b-[#e6e6e6] pb-1'>
                    <h2 class='text-base w-full mt-2 mb-0 lg:mb-1 text-center'>Order Status: ${statusUpper}</h2>
                    <div class="lg:max-w-[700px] track-step-container flex lg:w-[70%] lg:mx-[auto] lg:my-[40px] lg:mb-[35px] mt-2">
                        <div class="track-step track-ordered active text-center flex justify-center [flex-flow:column] items-center">
                            ${this.icons.trackConfirmed}
                            <span class='leading-tight block text-[12px] mt-[3px] h-[75px]'>Ordered</span>
                        </div>
                        <div class="track-line w-1/5 mt-[5%] lg:mt-[2.5%] block mx-[auto] my-[0] h-[2px] bg-[#d1d1d1]"></div>
                        <div class="track-step track-pickup active text-center flex justify-center [flex-flow:column] items-center">
                            ${trackPickupIcon}
                            <span class='leading-tight block text-[12px] mt-[3px] h-[75px]'>Pick Up</span>
                        </div>
                        <div class="track-line w-1/5 mt-[5%] lg:mt-[2.5%] block mx-[auto] my-[0] h-[2px] bg-[#d1d1d1]"></div>
                        <div class="track-step track-intransit active text-center flex justify-center [flex-flow:column] items-center">
                            ${trackTransitIcon}
                            <span class='leading-tight block text-[12px] mt-[3px] h-[75px]'>In Transit</span>
                        </div>
                        <div class="track-line w-1/5 mt-[5%] lg:mt-[2.5%] block mx-[auto] my-[0] h-[2px] bg-[#d1d1d1]"></div>
                        <div class="track-step track-delivered active text-center flex justify-center [flex-flow:column] items-center">
                            ${trackDeliveredIcon}
                            <span class='leading-tight block text-[12px] mt-[3px] h-[75px]'>Delivered</span>
                        </div>
                    </div>
                    ${
                      status === 'initial' || !status
                        ? `<p class='mb-1 text-center'>Your order has been placed successfully.</p>`
                        : ''
                    }
                    ${status === 'intransit' ? `<p class='mb-1 text-center'>Your order is on its way</p>` : ''}
                    ${status === 'pickup' ? `<p class='mb-1 text-center'>Your order has been picked up</p>` : ''}
                    ${status === 'delivered' ? `<p class='mb-1 text-center'>Your order has been delivered</p>` : ''}
                </div>
                <div class='flex flex-wrap w-full justify-center pb-0 lg:pt-3 lg:border-b-[1px_solid_#e6e6e6]'>
                    <h2 class='text-base mt-0 lg:mt-2 mb-1 text-center'>Your Order Details ${orderNumber}</h2>
                    <div class="w-full overflow-x-auto">
                        <table width="100%" class='border-[1px] border-[solid] border-[#e6e6e6] border-b-[0] rounded-[5px] mx-[0] my-[40px] bg-transparent border-collapse [border-spacing:0] lg:mb-1'>
                            <thead>
                                <tr>
                                    <th class='text-[12px] text-[#484848] p-[15px] text-left'>Product</th>
                                    <th class='text-[12px] text-[#484848] p-[15px] text-left'>Qty</th>
                                    <th class='text-[12px] text-[#484848] p-[15px] text-left'>Tracking Number</th>
                                    <th class='text-[12px] text-[#484848] p-[15px] text-left'>Carrier</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${itemsHtml}
                            </tbody>
                        </table>
                    </div>
                </div>
            `;
        }

        async fetchTrack(trackingNumber) {
          this.btn.innerText = 'Tracking...';
          this.resultContainer.style.display = 'none';

          const date = new Date();
          const tse = date.getTime();
          const dataString = "{tracking:'" + trackingNumber + "',time:" + tse + '}';

          while (typeof window.encryptParam !== 'function') {
            await new Promise(resolve => setTimeout(resolve, 50));
          }

          const signature = window.encryptParam(dataString);
          const site = this.dataset.site || 'us';
          const storeBrand = 'cocoandeve_shopify_' + site;

          fetch(
            'https://s-app.cocoandeve.com/track_order.json?order_number=' +
              trackingNumber +
              '&brand_name=' +
              storeBrand +
              '&signature=' +
              signature,
            { method: 'GET' }
          )
            .then((response) => response.json())
            .then((data) => {
              this.resultContainer.style.display = 'block';
              if (data && data.data) {
                this.resultContainer.innerHTML = this.renderResult(data.data);
              } else {
                this.resultContainer.innerHTML = this.renderResult({});
              }
              this.btn.innerText = 'Track Order';
            })
            .catch((error) => {
              console.error('Error tracking order:', error);
              this.btn.innerText = 'Track Order';
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
